(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["exploded-diagram"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('exploded-diagram-viewer')) return;

    class ExplodedDiagram extends HTMLElement {
      connectedCallback() {
        if (this.initialized) {
          if (this.handleFullscreenChange) {
            document.addEventListener('fullscreenchange', this.handleFullscreenChange);
          }
          if (this.handleDocumentKeydown) {
            document.addEventListener('keydown', this.handleDocumentKeydown);
          }
          if (this.handleDocumentClick) {
            document.addEventListener('click', this.handleDocumentClick);
          }
          if (this.mobileLayoutQuery && this.handleResponsiveLayout) {
            this.mobileLayoutQuery.addEventListener('change', this.handleResponsiveLayout);
          }
          return;
        }
        this.initialized = true;
        this.scale = 1;
        this.minimumScale = 1;
        this.maximumScale = 3;
        this.scaleStep = 0.25;
        this.diagramPane = this.querySelector('.exploded-diagram__diagram-pane');
        this.layout = this.querySelector('.exploded-diagram__layout');
        this.partsPane = this.querySelector('.exploded-diagram__parts-pane');
        this.surface = this.querySelector('[data-ed-surface]');
        this.fullscreenTarget = this.diagramPane || this.surface;
        this.viewport = this.querySelector('[data-ed-viewport]');
        this.diagramImage = this.querySelector('.exploded-diagram__image');
        this.highResolutionLoaded = !this.viewport?.dataset.edHiresSrc;
        this.tableScroll = this.querySelector('[data-ed-table-scroll]');
        this.table = this.querySelector('[data-ed-table]');
        this.tableBody = this.querySelector('[data-ed-table-body]');
        this.scheduleStatus = this.querySelector('[data-ed-schedule-status]');
        this.partsCount = this.querySelector('[data-ed-parts-count]');
        this.rows = [];
        this.parts = [];
        this.search = this.querySelector('[data-ed-search]');
        this.searchClear = this.querySelector('[data-ed-search-clear]');
        this.resultCount = this.querySelector('[data-ed-result-count]');
        this.noResults = this.querySelector('[data-ed-no-results]');
        this.descriptionDialog = this.querySelector('[data-ed-description-dialog]');
        this.quickPreview = this.querySelector('[data-ed-quick-preview]');
        this.toast = this.querySelector('[data-ed-toast]');
        this.listSummary = this.querySelector('[data-ed-list-summary]');
        this.listCount = this.querySelector('[data-ed-list-count]');
        this.viewListButton = this.querySelector('[data-ed-view-list]');
        this.addListCartButtons = [...this.querySelectorAll('[data-ed-add-list-cart]')];
        this.listFooter = this.querySelector('[data-ed-list-footer]');
        this.listQuantity = this.querySelector('[data-ed-list-quantity]');
        this.listPrice = this.querySelector('[data-ed-list-price]');
        this.listWarning = this.querySelector('[data-ed-list-warning]');
        this.listWarningText = this.querySelector('[data-ed-list-warning-text]');
        this.listMessage = this.querySelector('[data-ed-list-message]');
        this.liveRegion = this.querySelector('[data-ed-live-region]');
        this.zoomOutput = this.querySelector('[data-ed-zoom-output]');
        this.zoomIn = this.querySelector('[data-ed-zoom-in]');
        this.zoomOut = this.querySelector('[data-ed-zoom-out]');
        this.fullscreenButton = this.querySelector('[data-ed-fullscreen]');
        this.scheduleToggle = this.querySelector('[data-ed-schedule-toggle]');
        this.scheduleToggleLabel = this.querySelector('[data-ed-schedule-toggle-label]');
        this.productCache = new Map();
        this.descriptionHtmlCache = new Map();
        this.queuedHandles = new Set();
        this.productQueue = [];
        this.activeProductRequests = 0;
        this.maximumProductRequests = 2;
        this.partsList = new Map();
        this.listMode = false;
        this.pinchState = null;
        this.wheelZoomFrame = null;
        this.wheelZoomDelta = 0;
        this.wheelZoomPoint = null;
        this.pinchFrame = null;
        this.pendingPinch = null;
        this.dragFrame = null;
        this.pendingDrag = null;
        this.handleFullscreenChange = () => this.updateFullscreenState();
        this.handleDocumentKeydown = (event) => {
          if (event.key === 'Escape' && this.diagramPane?.dataset.edFullscreenFallback === 'true') {
            this.exitFallbackFullscreen();
          }
        };
        this.handleDocumentClick = (event) => {
          if (this.quickPreview?.hidden || !(event.target instanceof Element)) return;
          if (this.quickPreview.contains(event.target)) return;
          if (this.contains(event.target) && event.target.closest('[data-ed-select-part]')) return;
          this.closeQuickPreview();
        };
        this.mobileLayoutQuery = window.matchMedia('(max-width: 749px)');
        this.handleResponsiveLayout = (event) => {
          if (event.matches && this.dataset.scheduleCollapsed === 'true') {
            this.setScheduleCollapsed(false);
          }
        };
        this.mobileLayoutQuery.addEventListener('change', this.handleResponsiveLayout);
        this.totalRows = 0;
        this.bindEvents();
        this.setupPaneHeightSync();
        this.updateScale(false);

        if (!this.fullscreenTarget && this.fullscreenButton) {
          this.fullscreenButton.hidden = true;
        } else {
          document.addEventListener('fullscreenchange', this.handleFullscreenChange);
          this.updateFullscreenState();
        }
        document.addEventListener('keydown', this.handleDocumentKeydown);
        document.addEventListener('click', this.handleDocumentClick);

        if (this.dataset.csvUrl) {
          this.loadSchedule();
        } else {
          this.updateResultCount(0);
        }
      }

      disconnectedCallback() {
        document.removeEventListener('fullscreenchange', this.handleFullscreenChange);
        document.removeEventListener('keydown', this.handleDocumentKeydown);
        document.removeEventListener('click', this.handleDocumentClick);
        this.mobileLayoutQuery?.removeEventListener('change', this.handleResponsiveLayout);
        this.rowObserver?.disconnect();
        this.paneResizeObserver?.disconnect();
        this.csvController?.abort();
        this.unlockPageScroll();
        this.exitFallbackFullscreen();
        this.cleanupPrintView();
        window.clearTimeout(this.toastTimer);
        window.clearTimeout(this.toastHideTimer);
        window.clearTimeout(this.zoomAnnouncementTimer);
        window.clearTimeout(this.hydrationTimer);
        if (this.hydrationIdleTask && 'cancelIdleCallback' in window) {
          window.cancelIdleCallback(this.hydrationIdleTask);
        }
        if (this.wheelZoomFrame) cancelAnimationFrame(this.wheelZoomFrame);
        if (this.pinchFrame) cancelAnimationFrame(this.pinchFrame);
        if (this.dragFrame) cancelAnimationFrame(this.dragFrame);
      }

      bindEvents() {
        this.addEventListener('click', (event) => {
          const quantityButton = event.target.closest('[data-ed-quantity-change]');
          if (quantityButton) {
            const input = quantityButton.closest('[data-ed-add-form]')?.querySelector('input[name="quantity"]');
            if (!input) return;
            if (Number(quantityButton.dataset.edQuantityChange) < 0) {
              input.stepDown();
            } else {
              input.stepUp();
            }
            input.dispatchEvent(new Event('change', { bubbles: true }));
            return;
          }

          if (event.target.closest('[data-ed-search-clear]')) {
            if (this.search) this.search.value = '';
            this.applyFilters();
            this.search?.focus();
            return;
          }

          const addListButton = event.target.closest('[data-ed-add-list]');
          if (addListButton) {
            const added = this.addPartToList(Number(addListButton.dataset.edAddList));
            if (added && addListButton.dataset.edListContext === 'quick') this.closeQuickPreview();
            if (added && addListButton.dataset.edListContext === 'dialog') this.closeDescription();
            return;
          }

          const removeListButton = event.target.closest('[data-ed-remove-list]');
          if (removeListButton) {
            this.removePartFromList(Number(removeListButton.dataset.edRemoveList));
            return;
          }

          if (event.target.closest('[data-ed-view-list]')) {
            this.toggleListView();
            return;
          }

          if (event.target.closest('[data-ed-clear-list]')) {
            this.clearPartsList();
            return;
          }

          const addListCartButton = event.target.closest('[data-ed-add-list-cart]');
          if (addListCartButton) {
            this.addListToCart(addListCartButton);
            return;
          }

          if (event.target.closest('[data-ed-dialog-read-more]')) {
            this.toggleDialogDescription();
            return;
          }

          if (event.target.closest('[data-ed-quick-read-more]')) {
            const index = this.activeSelectedPart?.index;
            if (Number.isInteger(index)) this.openDescription(index);
            return;
          }

          const quickCartButton = event.target.closest('[data-ed-quick-add-cart]');
          if (quickCartButton) {
            this.addSelectedPartToCart(quickCartButton);
            return;
          }

          const toastAction = event.target.closest('[data-ed-toast-action]');
          if (toastAction) {
            if (toastAction.dataset.edToastAction === 'cart') {
              this.openCartDrawer(toastAction);
            } else if (toastAction.dataset.edToastAction === 'list') {
              this.showListView();
            }
            this.hideToast();
            return;
          }

          const descriptionButton = event.target.closest('[data-ed-open-description]');
          if (descriptionButton) {
            if (
              descriptionButton.matches('a') &&
              (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0)
            ) return;
            event.preventDefault();
            this.openDescription(Number(descriptionButton.dataset.edOpenDescription));
            return;
          }

          const partCell = event.target.closest('[data-ed-open-product]');
          if (partCell && !event.target.closest('a, button, input, [data-ed-quantity-stepper]')) {
            this.openDescription(Number(partCell.dataset.edOpenProduct));
            return;
          }

          if (event.target.closest('[data-ed-dialog-close]')) {
            this.closeDescription();
            return;
          }

          const selector = event.target.closest('[data-ed-select-part]');
          if (selector) {
            this.selectPart(selector.dataset.edSelectPart);
            return;
          }

          if (event.target.closest('[data-ed-zoom-in]')) {
            this.setScale(this.scale + this.scaleStep);
            return;
          }

          if (event.target.closest('[data-ed-zoom-out]')) {
            this.setScale(this.scale - this.scaleStep);
            return;
          }

          if (event.target.closest('[data-ed-reset]')) {
            this.resetDiagram();
            return;
          }

          if (event.target.closest('[data-ed-print]')) {
            this.printDiagram();
            return;
          }

          if (event.target.closest('[data-ed-fullscreen]')) {
            this.toggleFullscreen();
            return;
          }

          if (event.target.closest('[data-ed-schedule-toggle]')) {
            this.toggleSchedule();
            return;
          }
        });

        this.addEventListener('submit', (event) => {
          const form = event.target.closest('[data-ed-add-form]');
          if (!form) return;
          event.preventDefault();
          this.addToCart(form);
        });

        this.addEventListener('change', (event) => {
          const quantityInput = event.target.closest('[data-ed-add-form] input[name="quantity"]');
          if (!quantityInput) return;
          const form = quantityInput.closest('[data-ed-add-form]');
          const index = Number(form?.dataset.edPartIndex);
          const quantity = Math.max(
            1,
            Math.floor(Number(quantityInput.value) || 1)
          );
          quantityInput.value = String(quantity);
          if (this.partsList.has(index)) {
            const entry = this.partsList.get(index);
            entry.quantity = quantity;
            this.updateListSummary();
          }
        });

        this.search?.addEventListener('input', () => this.applyFilters());
        this.tableScroll?.addEventListener('wheel', (event) => this.containScheduleScroll(event), { passive: false });
        this.surface?.addEventListener('wheel', (event) => this.zoomWithWheel(event), { passive: false, capture: true });
        this.surface?.addEventListener('keydown', (event) => this.handleDiagramKeydown(event));
        this.surface?.addEventListener('pointerdown', (event) => this.startDrag(event));
        this.surface?.addEventListener('pointermove', (event) => this.drag(event));
        this.surface?.addEventListener('pointerup', (event) => this.endDrag(event));
        this.surface?.addEventListener('pointercancel', (event) => this.endDrag(event));
        this.surface?.addEventListener('touchstart', (event) => this.startPinch(event), { passive: false });
        this.surface?.addEventListener('touchmove', (event) => this.pinch(event), { passive: false });
        this.surface?.addEventListener('touchend', (event) => this.endPinch(event));
        this.surface?.addEventListener('touchcancel', (event) => this.endPinch(event));
        this.descriptionDialog?.addEventListener('click', (event) => {
          if (event.target === this.descriptionDialog) this.closeDescription();
        });
        this.descriptionDialog?.addEventListener('close', () => {
          this.activeDialogPart = null;
          this.unlockPageScroll();
        });
        this.addEventListener('keydown', (event) => {
          const partCell = event.target.closest('[data-ed-open-product]');
          if (!partCell || event.target.closest('a, button, input')) return;
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            this.openDescription(Number(partCell.dataset.edOpenProduct));
          }
        });
      }

      setupPaneHeightSync() {
        if (!this.diagramPane || !this.partsPane) return;
        const sync = () => {
          if (window.matchMedia('(min-width: 1100px)').matches) {
            const height = Math.ceil(this.diagramPane.getBoundingClientRect().height);
            if (height > 0) this.style.setProperty('--ed-diagram-pane-height', `${height}px`);
          } else {
            this.style.removeProperty('--ed-diagram-pane-height');
          }
        };
        this.paneResizeObserver = new ResizeObserver(sync);
        this.paneResizeObserver.observe(this.diagramPane);
        window.requestAnimationFrame(sync);
      }

      normalize(value) {
        return String(value || '').toLocaleLowerCase().normalize('NFKD').replace(/\p{Diacritic}/gu, '');
      }

      normalizeHeader(value) {
        return this.normalize(value)
          .replace(/^\ufeff/, '')
          .replace(/&/g, ' and ')
          .replace(/[^a-z0-9]+/g, '_')
          .replace(/^_+|_+$/g, '');
      }

      parseCsv(text) {
        const records = [];
        let record = [];
        let field = '';
        let quoted = false;

        for (let index = 0; index < text.length; index += 1) {
          const character = text[index];
          if (quoted) {
            if (character === '"' && text[index + 1] === '"') {
              field += '"';
              index += 1;
            } else if (character === '"') {
              quoted = false;
            } else {
              field += character;
            }
          } else if (character === '"') {
            quoted = true;
          } else if (character === ',') {
            record.push(field);
            field = '';
          } else if (character === '\n') {
            record.push(field.replace(/\r$/, ''));
            if (record.some((value) => value.trim() !== '')) records.push(record);
            record = [];
            field = '';
          } else {
            field += character;
          }
        }

        record.push(field.replace(/\r$/, ''));
        if (record.some((value) => value.trim() !== '')) records.push(record);
        if (quoted) throw new Error('The CSV contains an unclosed quoted field.');
        if (records.length < 2) throw new Error('The CSV has no schedule rows.');

        const headers = records.shift().map((header) => this.normalizeHeader(header));
        if (!headers.some(Boolean)) throw new Error('The CSV header row is empty.');

        return records.map((values) => {
          const row = {};
          headers.forEach((header, index) => {
            if (header) row[header] = String(values[index] || '').trim();
          });
          return row;
        });
      }

      firstValue(row, names) {
        for (const name of names) {
          const value = row[name];
          if (value !== undefined && String(value).trim() !== '') return String(value).trim();
        }
        return '';
      }

      extractHandle(value) {
        const source = String(value || '').trim();
        if (!source) return '';
        const match = source.match(/\/products\/([^/?#]+)/i);
        return decodeURIComponent(match ? match[1] : source)
          .replace(/^\/+|\/+$/g, '')
          .split(/[?#]/)[0];
      }

      normalizeCsvRow(row, index) {
        const reference = this.firstValue(row, [
          'reference',
          'ref',
          'reference_number',
          'callout',
          'callout_number',
          'annotation',
          'annotation_number'
        ]);
        const productSource = this.firstValue(row, [
          'product_handle',
          'shopify_product_handle',
          'handle',
          'product_url',
          'shopify_product'
        ]);
        const sku = this.firstValue(row, ['sku', 'part_sku', 'recmar_sku', 'product_sku']);
        return {
          index,
          reference,
          annotation: this.firstValue(row, ['annotation', 'annotation_number']),
          title: this.firstValue(row, [
            'part_title',
            'title',
            'parts_description',
            'part_description',
            'parts'
          ]),
          productTitle: '',
          sku,
          description: this.firstValue(row, [
            'product_description',
            'description',
            'long_description'
          ]),
          descriptionHtml: '',
          productDescriptionHtml: '',
          fitment: this.firstValue(row, ['fitment_note', 'fitment', 'application_note']),
          serialBreak: this.firstValue(row, [
            'serial_break',
            'serial_range',
            'serial_scope',
            'variant_scope',
            'application_serial_range'
          ]),
          oemReferences: [
            this.firstValue(row, ['oem_cross_reference_1', 'oem_reference_1', 'oem_ref_1', 'cross_reference_1']),
            this.firstValue(row, ['oem_cross_reference_2', 'oem_reference_2', 'oem_ref_2', 'cross_reference_2']),
            this.firstValue(row, ['oem_cross_reference_3', 'oem_reference_3', 'oem_ref_3', 'cross_reference_3'])
          ],
          unit: this.firstValue(row, ['unit', 'un', 'units', 'quantity_per_assembly']) || '1',
          productHandle: this.extractHandle(productSource),
          variantId: this.firstValue(row, ['variant_id', 'shopify_variant_id']).replace(/\D/g, ''),
          variantSku: this.firstValue(row, ['variant_sku', 'shopify_variant_sku']) || sku,
          productUrl: this.firstValue(row, ['product_url']),
          snapshotPrice: this.firstValue(row, ['unit_price', 'price']),
          snapshotStock: this.firstValue(row, ['in_stock', 'availability', 'stock_status']),
          raw: row
        };
      }

      async loadSchedule() {
        this.csvController?.abort();
        this.csvController = new AbortController();
        this.setScheduleStatus('loading', 'Loading parts schedule…');

        try {
          const response = await fetch(this.dataset.csvUrl, {
            headers: { Accept: 'text/csv,text/plain;q=0.9,*/*;q=0.5' },
            credentials: 'same-origin',
            cache: 'force-cache',
            signal: this.csvController.signal
          });
          if (!response.ok) throw new Error(`The CSV returned HTTP ${response.status}.`);
          const rawRows = this.parseCsv(await response.text());
          this.parts = rawRows
            .map((row, index) => this.normalizeCsvRow(row, index))
            .filter((part) => part.reference || part.title || part.productHandle || part.sku);
          if (!this.parts.length) throw new Error('The CSV has no usable schedule rows.');
          if (!this.parts.some((part) => part.reference)) {
            throw new Error('Add a reference, ref, callout or annotation column to the CSV.');
          }

          this.annotateReferenceAlternatives();
          this.renderSchedule();
          this.setScheduleStatus('ready');
          this.scheduleProductHydration();
        } catch (error) {
          if (error.name === 'AbortError') return;
          this.table.hidden = true;
          this.setScheduleStatus('error', `Parts schedule could not be loaded. ${error.message}`);
          this.updateResultCount(0);
          this.announce(error.message);
        }
      }

      annotateReferenceAlternatives() {
        const groups = new Map();
        this.parts.forEach((part) => {
          const key = this.normalize(part.reference);
          if (!key) return;
          const group = groups.get(key) || [];
          group.push(part);
          groups.set(key, group);
        });
        groups.forEach((group) => {
          if (group.length < 2) return;
          group.forEach((part, index) => {
            const distinction = part.serialBreak || part.fitment;
            part.referenceAlternativeLabel = distinction
              ? `Serial / application: ${distinction}`
              : `Alternative ${index + 1} of ${group.length}`;
            part.referenceAlternativeIndex = index + 1;
            part.referenceAlternativeCount = group.length;
          });
        });
      }

      setScheduleStatus(state, message = '') {
        this.dataset.scheduleState = state;
        if (!this.scheduleStatus) return;
        this.scheduleStatus.dataset.state = state;
        if (state === 'ready') {
          this.scheduleStatus.hidden = true;
          return;
        }
        this.scheduleStatus.hidden = false;
        this.scheduleStatus.replaceChildren();
        if (state === 'loading') {
          const spinner = document.createElement('span');
          spinner.className = 'exploded-diagram__schedule-spinner';
          spinner.setAttribute('aria-hidden', 'true');
          this.scheduleStatus.append(spinner);
        }
        const copy = document.createElement('span');
        copy.textContent = message;
        this.scheduleStatus.append(copy);
      }

      renderSchedule() {
        const fragment = document.createDocumentFragment();
        this.rows = this.parts.map((part) => {
          const row = this.createRow(part);
          fragment.append(row);
          return row;
        });
        this.tableBody.replaceChildren(fragment);
        this.totalRows = this.rows.length;
        this.partsCount.textContent = String(this.totalRows);
        this.updateOemColumns();
        this.syncPartListActions();
        this.table.hidden = false;
        this.applyFilters();
      }

      createRow(part) {
        const row = document.createElement('tr');
        row.className = 'exploded-diagram__part-row';
        row.dataset.edPartRow = '';
        row.dataset.partKey = String(part.index);
        row._explodedDiagramPart = part;

        const referenceCell = document.createElement('th');
        referenceCell.scope = 'row';
        referenceCell.dataset.label = 'Reference';
        const referenceActions = document.createElement('div');
        referenceActions.className = 'exploded-diagram__reference-actions';
        const referenceButton = document.createElement('button');
        referenceButton.className = 'exploded-diagram__reference-button';
        referenceButton.type = 'button';
        referenceButton.dataset.edSelectPart = String(part.index);
        const referenceLabel = part.referenceAlternativeLabel
          ? `Select reference ${part.reference || part.index + 1}, ${part.referenceAlternativeLabel}`
          : `Select reference ${part.reference || part.index + 1}`;
        referenceButton.setAttribute('aria-label', referenceLabel);
        const referenceText = document.createElement('span');
        referenceText.textContent = part.reference || String(part.index + 1);
        referenceButton.append(referenceText);
        referenceActions.append(referenceButton);
        referenceCell.append(referenceActions);
        row.append(referenceCell);

        const partCell = document.createElement('td');
        partCell.className = 'exploded-diagram__part-cell';
        partCell.dataset.label = 'Part / description';
        partCell.dataset.edOpenProduct = String(part.index);
        partCell.tabIndex = 0;
        partCell.setAttribute('aria-label', `Open product details for ${part.title || `reference ${part.reference}`}`);
        const title = document.createElement(part.productHandle ? 'a' : 'button');
        if (part.productHandle) {
          title.href = `${this.dataset.productsRoot}${encodeURIComponent(part.productHandle)}`;
        } else {
          title.type = 'button';
        }
        title.className = 'exploded-diagram__part-title';
        title.dataset.edPartTitle = '';
        title.dataset.edOpenDescription = String(part.index);
        const catalogueTitle = document.createElement('span');
        catalogueTitle.className = 'exploded-diagram__part-title-catalogue';
        catalogueTitle.dataset.edCatalogueTitle = '';
        catalogueTitle.textContent = part.title || 'Loading product…';
        const titleSeparator = document.createElement('span');
        titleSeparator.className = 'exploded-diagram__part-title-separator';
        titleSeparator.dataset.edTitleSeparator = '';
        titleSeparator.textContent = ' — ';
        titleSeparator.hidden = true;
        const shopifyTitle = document.createElement('span');
        shopifyTitle.className = 'exploded-diagram__part-title-shopify';
        shopifyTitle.dataset.edShopifyTitle = '';
        shopifyTitle.hidden = true;
        title.append(catalogueTitle, titleSeparator, shopifyTitle);
        partCell.append(title);

        const sku = document.createElement('span');
        sku.className = 'exploded-diagram__sku';
        sku.dataset.edPartSku = '';
        sku.textContent = part.sku ? `SKU: ${part.sku}` : '';
        sku.hidden = !part.sku;
        partCell.append(sku);

        if (part.referenceAlternativeLabel) {
          const serialBreak = document.createElement('span');
          serialBreak.className = 'exploded-diagram__serial-break-badge';
          serialBreak.textContent = part.referenceAlternativeLabel;
          partCell.append(serialBreak);
        }

        const mobileOemReferences = part.oemReferences.filter(Boolean);
        if (mobileOemReferences.length) {
          const mobileOem = document.createElement('span');
          mobileOem.className = 'exploded-diagram__mobile-oem';
          mobileOem.textContent = `OEM: ${mobileOemReferences.join(' · ')}`;
          mobileOem.title = mobileOemReferences.join(', ');
          partCell.append(mobileOem);
        }

        const description = document.createElement('button');
        description.className = 'exploded-diagram__description-button';
        description.type = 'button';
        description.dataset.edOpenDescription = String(part.index);
        description.dataset.edPartDescription = '';
        description.textContent = part.description;
        description.hidden = !part.description;
        description.setAttribute('aria-label', `Read full description for ${part.title || `reference ${part.reference}`}`);
        partCell.append(description);

        if (part.fitment) {
          const fitment = document.createElement('span');
          fitment.className = 'exploded-diagram__fitment-note';
          fitment.textContent = part.fitment;
          partCell.append(fitment);
        }
        row.append(partCell);

        part.oemReferences.forEach((reference, oemIndex) => {
          const cell = document.createElement('td');
          cell.className = `exploded-diagram__oem-reference${reference ? '' : ' is-empty'}`;
          cell.dataset.label = `OEM / cross-ref. ${oemIndex + 1}`;
          cell.dataset.edOemColumn = String(oemIndex + 1);
          cell.dataset.edOpenProduct = String(part.index);
          cell.textContent = reference;
          row.append(cell);
        });

        const unitCell = document.createElement('td');
        unitCell.className = 'exploded-diagram__assembly-quantity';
        unitCell.dataset.label = 'UN';
        unitCell.dataset.edOpenProduct = String(part.index);
        unitCell.title = 'UN is the number of this part required for one complete assembly.';
        const unitValue = document.createElement('span');
        unitValue.textContent = part.unit;
        unitCell.append(unitValue);
        row.append(unitCell);

        const priceCell = document.createElement('td');
        priceCell.className = 'exploded-diagram__price';
        priceCell.dataset.label = 'Unit price';
        priceCell.dataset.edPrice = '';
        priceCell.dataset.edOpenProduct = String(part.index);
        priceCell.textContent = part.productHandle ? 'Checking…' : (part.snapshotPrice || '—');
        row.append(priceCell);

        const orderCell = document.createElement('td');
        orderCell.className = 'exploded-diagram__order-cell';
        orderCell.dataset.label = 'Order';
        orderCell.dataset.edOpenProduct = String(part.index);
        orderCell.append(this.createOrderForm(part, { context: 'row' }));
        row.append(orderCell);
        this.updateRowSearch(row);
        return row;
      }

      createOrderForm(part, { context = 'row', quantity = 1 } = {}) {
        part.orderState = part.orderState || {
          state: part.productHandle ? 'checking' : 'not_found',
          label: part.productHandle ? 'Checking stock…' : 'Product not found',
          enabled: false,
          variantId: ''
        };
        const form = document.createElement('form');
        form.className = 'exploded-diagram__add-form exploded-diagram__add-form--disabled';
        form.action = this.dataset.cartAddUrl;
        form.method = 'post';
        form.dataset.edAddForm = '';
        form.dataset.edPartIndex = String(part.index);
        form.dataset.edFormContext = context;

        const variantInput = document.createElement('input');
        variantInput.type = 'hidden';
        variantInput.name = 'id';
        variantInput.dataset.edVariantId = '';
        form.append(variantInput);

        const status = document.createElement('div');
        status.className = 'exploded-diagram__order-status';
        status.dataset.edOrderStatus = '';
        status.append(this.createAvailability(part.orderState.state, part.orderState.label));
        form.append(status);

        const controls = document.createElement('div');
        controls.className = 'exploded-diagram__order-controls';
        const stepper = document.createElement('div');
        stepper.className = 'exploded-diagram__quantity-stepper exploded-diagram__quantity-stepper--disabled';
        stepper.dataset.edQuantityStepper = '';
        stepper.append(
          this.createQuantityButton(-1, part),
          this.createQuantityInput(part, quantity),
          this.createQuantityButton(1, part)
        );
        controls.append(stepper);

        const addButton = document.createElement('button');
        addButton.className = 'exploded-diagram__add-button exploded-diagram__add-button--disabled';
        addButton.type = 'submit';
        addButton.disabled = true;
        addButton.setAttribute('aria-label', `Add ${part.title || `reference ${part.reference}`} to cart`);
        addButton.title = 'Add to cart';
        addButton.append(this.createBasketIcon());
        const label = document.createElement('span');
        label.className = 'visually-hidden';
        label.dataset.edButtonLabel = '';
        label.textContent = context === 'dialog' ? 'Add item to cart' : 'Add to cart';
        addButton.append(label);
        const spinner = document.createElement('span');
        spinner.className = 'exploded-diagram__button-spinner';
        spinner.setAttribute('aria-hidden', 'true');
        addButton.append(spinner);
        controls.append(addButton);

        if (context === 'row' || context === 'dialog') {
          const listButton = document.createElement('button');
          listButton.className = 'exploded-diagram__add-list';
          listButton.type = 'button';
          listButton.disabled = true;
          listButton.dataset.edAddList = String(part.index);
          listButton.dataset.edListContext = context;
          listButton.setAttribute('aria-label', `Add ${part.title || `reference ${part.reference}`} to parts list`);
          listButton.textContent = '+ List';
          listButton.hidden = false;
          controls.append(listButton);
        }

        if (context === 'row') {
          const removeButton = document.createElement('button');
          removeButton.className = 'exploded-diagram__remove-list';
          removeButton.type = 'button';
          removeButton.dataset.edRemoveList = String(part.index);
          removeButton.setAttribute('aria-label', `Remove ${part.title || `reference ${part.reference}`} from list`);
          removeButton.title = 'Remove from list';
          removeButton.hidden = true;
          const removeIcon = document.createElement('span');
          removeIcon.className = 'exploded-diagram__remove-list-x';
          removeIcon.setAttribute('aria-hidden', 'true');
          removeIcon.textContent = '×';
          const removeLabel = document.createElement('span');
          removeLabel.className = 'exploded-diagram__remove-list-label';
          removeLabel.textContent = 'Remove from list';
          removeButton.append(removeIcon, removeLabel);
          controls.append(removeButton);
        }
        form.append(controls);
        return form;
      }

      createAvailability(state, label) {
        const availability = document.createElement('span');
        availability.className = `exploded-diagram__availability exploded-diagram__availability--${state}`;
        const dot = document.createElement('span');
        dot.className = 'exploded-diagram__availability-dot';
        dot.setAttribute('aria-hidden', 'true');
        const text = document.createElement('span');
        text.textContent = label;
        availability.append(dot, text);
        return availability;
      }

      createQuantityButton(direction, part) {
        const button = document.createElement('button');
        button.type = 'button';
        button.disabled = true;
        button.dataset.edQuantityChange = String(direction);
        button.textContent = direction < 0 ? '−' : '+';
        button.setAttribute('aria-label', `${direction < 0 ? 'Decrease' : 'Increase'} purchase quantity for ${part.title || `reference ${part.reference}`}`);
        return button;
      }

      createQuantityInput(part, quantity = 1) {
        const input = document.createElement('input');
        input.className = 'exploded-diagram__quantity-input';
        input.type = 'number';
        input.name = 'quantity';
        input.value = String(Math.max(1, Math.floor(Number(quantity) || 1)));
        input.min = '1';
        input.inputMode = 'numeric';
        input.disabled = true;
        input.setAttribute('aria-label', `Purchase quantity for ${part.title || `reference ${part.reference}`}`);
        return input;
      }

      createBasketIcon() {
        const icon = document.createElement('span');
        icon.className = 'exploded-diagram__basket-icon';
        icon.setAttribute('aria-hidden', 'true');
        return icon;
      }

      safeProductUrl(part, variantId = '') {
        let url = part.productUrl;
        if (!url && part.productHandle) {
          url = `${this.dataset.productsRoot}${encodeURIComponent(part.productHandle)}`;
        }
        if (!url) return '#';
        try {
          const parsed = new URL(url, window.location.origin);
          if (!['http:', 'https:'].includes(parsed.protocol)) return '#';
          if (variantId) parsed.searchParams.set('variant', variantId);
          return parsed.href;
        } catch {
          return '#';
        }
      }

      safeImageUrl(value) {
        const source = typeof value === 'string' ? value : value?.src;
        if (!source) return '';
        try {
          const parsed = new URL(source, window.location.origin);
          return ['http:', 'https:'].includes(parsed.protocol) ? parsed.href : '';
        } catch {
          return '';
        }
      }

      updateOemColumns() {
        const populated = [0, 1, 2].filter((index) =>
          this.parts.some((part) => Boolean(part.oemReferences[index]))
        );
        this.table.classList.remove(
          'exploded-diagram__table--oem-0',
          'exploded-diagram__table--oem-1',
          'exploded-diagram__table--oem-2',
          'exploded-diagram__table--oem-3'
        );
        this.table.classList.add(`exploded-diagram__table--oem-${populated.length}`);
        [1, 2, 3].forEach((column) => {
          const show = populated.includes(column - 1);
          this.querySelectorAll(`[data-ed-oem-column="${column}"]`).forEach((element) => {
            element.hidden = !show;
          });
        });
      }

      applyFilters() {
        const query = this.normalize(this.search?.value);
        let visible = 0;

        if (this.searchClear) this.searchClear.hidden = !query;

        this.rows.forEach((row) => {
          const matchesQuery = !query || this.normalize(row.dataset.search).includes(query);
          const matchesList = !this.listMode || this.partsList.has(row._explodedDiagramPart.index);
          row.hidden = !matchesQuery || !matchesList;
          if (!row.hidden) {
            visible += 1;
            const handle = row._explodedDiagramPart?.productHandle;
            if (query && handle) this.queueProduct(handle);
          }
        });

        this.updateResultCount(visible);
        if (this.noResults) this.noResults.hidden = visible !== 0;
      }

      updateResultCount(visible) {
        if (!this.resultCount) return;
        if (this.listMode) {
          const totalUnits = [...this.partsList.values()]
            .reduce((total, entry) => total + entry.quantity, 0);
          this.resultCount.textContent =
            `Showing ${visible} listed product${visible === 1 ? '' : 's'} · ${totalUnits} total unit${totalUnits === 1 ? '' : 's'}`;
          return;
        }
        this.resultCount.textContent = this.dataset.resultsTemplate
          .replace('__COUNT__', String(visible))
          .replace('__TOTAL__', String(this.totalRows));
      }

      updateRowSearch(row) {
        const part = row._explodedDiagramPart;
        row.dataset.search = [
          part.reference,
          part.annotation,
          part.title,
          part.productTitle,
          part.sku,
          part.description,
          part.fitment,
          ...part.oemReferences
        ].filter(Boolean).join(' ');
      }

      selectPart(key) {
        const row = this.rows.find((item) => item.dataset.partKey === key);
        if (!row) return;

        if (row.hidden) {
          if (this.search) this.search.value = '';
          this.applyFilters();
        }

        this.rows.forEach((item) => {
          const active = item === row;
          item.dataset.active = String(active);
          item.querySelector('[data-ed-select-part]')?.toggleAttribute('aria-current', active);
        });

        this.activeSelectedPart = row._explodedDiagramPart;
        if (this.table) this.table.dataset.hasActivePart = 'true';
        this.syncPartListActions();
        if (this.activeSelectedPart.productHandle) this.queueProduct(this.activeSelectedPart.productHandle);
        this.renderQuickPreview(this.activeSelectedPart);

        const scrollBehavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        if (this.tableScroll && this.tableScroll.scrollHeight > this.tableScroll.clientHeight + 1) {
          this.tableScroll.scrollTo({
            top: Math.max(0, row.offsetTop - (this.tableScroll.clientHeight / 2) + (row.offsetHeight / 2)),
            behavior: scrollBehavior
          });
        } else {
          row.scrollIntoView({ block: 'center', behavior: scrollBehavior });
        }

        const reference = row._explodedDiagramPart?.reference || '';
        this.announce(`Reference ${reference} selected`);
      }

      renderQuickPreview(part) {
        if (!part || !this.quickPreview) return;
        this.quickPreview.querySelector('[data-ed-quick-reference]').textContent = `Reference ${part.reference}`;
        const serialBreak = this.quickPreview.querySelector('[data-ed-quick-serial-break]');
        serialBreak.textContent = part.referenceAlternativeLabel || '';
        serialBreak.hidden = !part.referenceAlternativeLabel;
        this.quickPreview.querySelector('[data-ed-quick-title]').textContent =
          part.productTitle || part.title || 'Product details';
        const sku = this.quickPreview.querySelector('[data-ed-quick-sku]');
        sku.textContent = part.sku ? `SKU: ${part.sku}` : '';
        sku.hidden = !part.sku;
        const imageWrap = this.quickPreview.querySelector('[data-ed-quick-image-wrap]');
        const image = this.quickPreview.querySelector('[data-ed-quick-image]');
        imageWrap.hidden = !part.imageUrl;
        if (part.imageUrl) {
          image.src = part.imageUrl;
          image.alt = part.productTitle || part.title || 'Product image';
        } else {
          image.removeAttribute('src');
          image.alt = '';
        }
        const stock = this.quickPreview.querySelector('[data-ed-quick-stock]');
        stock.replaceChildren(this.createAvailability(
          part.orderState?.state || (part.productHandle ? 'checking' : 'not_found'),
          part.orderState?.label || (part.productHandle ? 'Checking stock…' : 'Product not found')
        ));
        this.renderPrice(this.quickPreview.querySelector('[data-ed-quick-price]'), part);
        const description = part.description || this.stripHtml(part.productDescriptionHtml) ||
          'No description is available for this part.';
        this.quickPreview.querySelector('[data-ed-quick-description]').textContent = description;
        const wrap = this.quickPreview.querySelector('[data-ed-quick-description-wrap]');
        wrap.dataset.expanded = 'false';
        const readMore = this.quickPreview.querySelector('[data-ed-quick-read-more]');
        readMore.hidden = description.length < 140 && !part.descriptionHtml && !part.productDescriptionHtml;
        readMore.textContent = 'Read more';
        readMore.removeAttribute('aria-expanded');
        const quickListButton = this.quickPreview.querySelector('[data-ed-add-list]');
        quickListButton.dataset.edAddList = String(part.index);
        const productLink = this.quickPreview.querySelector('[data-ed-quick-view-product]');
        const productUrl = this.safeProductUrl(part, part.resolvedVariantId);
        productLink.hidden = productUrl === '#';
        productLink.href = productUrl;
        const quickCartButton = this.quickPreview.querySelector('[data-ed-quick-add-cart]');
        quickCartButton.dataset.edPartIndex = String(part.index);
        this.resetQuickCartButton(quickCartButton, part);
        this.quickPreview.hidden = false;
        this.syncPartListActions(part);
      }

      resetQuickCartButton(button, part) {
        if (!button) return;
        window.clearTimeout(button._edLabelTimer);
        button.removeAttribute('aria-busy');
        let icon = button.querySelector('.exploded-diagram__basket-icon');
        if (!icon) {
          icon = this.createBasketIcon();
          button.prepend(icon);
        }
        let label = button.querySelector('[data-ed-button-label]');
        if (!label) {
          label = document.createElement('span');
          label.className = 'visually-hidden';
          label.dataset.edButtonLabel = '';
          button.append(label);
        }
        label.textContent = 'Add to cart';
        button.setAttribute('aria-label', `Add ${part.title || `reference ${part.reference}`} to cart`);
        button.disabled = !part.orderState?.enabled || !part.resolvedVariantId;
        const error = this.quickPreview.querySelector('[data-ed-quick-error]');
        error.textContent = '';
        error.hidden = true;
      }

      showQuickCartError(message) {
        const error = this.quickPreview?.querySelector('[data-ed-quick-error]');
        if (!error) return;
        error.textContent = message;
        error.hidden = !message;
      }

      closeQuickPreview() {
        if (this.quickPreview) this.quickPreview.hidden = true;
        this.activeSelectedPart = null;
        if (this.table) delete this.table.dataset.hasActivePart;
        this.rows.forEach((row) => {
          delete row.dataset.active;
          row.querySelector('[data-ed-select-part]')?.removeAttribute('aria-current');
        });
        this.syncPartListActions();
      }

      openDescription(index) {
        const part = this.parts.find((item) => item.index === index);
        if (!part || !this.descriptionDialog) return;
        this.closeQuickPreview();
        if (part.productHandle) this.queueProduct(part.productHandle);
        this.activeDialogPart = part;
        this.descriptionDialog.querySelector('[data-ed-dialog-reference]').textContent = `Reference ${part.reference}`;
        const serialBreak = this.descriptionDialog.querySelector('[data-ed-dialog-serial-break]');
        serialBreak.textContent = part.referenceAlternativeLabel || '';
        serialBreak.hidden = !part.referenceAlternativeLabel;
        this.descriptionDialog.querySelector('[data-ed-dialog-product-title]').textContent =
          part.productTitle || part.title || 'Product details';
        const catalogueTitle = this.descriptionDialog.querySelector('[data-ed-dialog-catalogue-title]');
        catalogueTitle.textContent = part.title && part.title !== part.productTitle
          ? `Catalogue description: ${part.title}`
          : '';
        catalogueTitle.hidden = !catalogueTitle.textContent;
        const productUrl = this.safeProductUrl(part, part.resolvedVariantId);
        const sku = this.descriptionDialog.querySelector('[data-ed-dialog-sku]');
        sku.textContent = part.sku ? `SKU: ${part.sku}` : '';
        sku.hidden = !part.sku;
        const imageWrap = this.descriptionDialog.querySelector('[data-ed-dialog-image-wrap]');
        const image = this.descriptionDialog.querySelector('[data-ed-dialog-image]');
        imageWrap.hidden = !part.imageUrl;
        if (part.imageUrl) {
          image.src = part.imageUrl;
          image.alt = part.title || 'Product image';
        } else {
          image.removeAttribute('src');
          image.alt = '';
        }
        const descriptionText = part.description || '';
        this.renderProductDescription(
          this.descriptionDialog.querySelector('[data-ed-dialog-description]'),
          part,
          'No extended description is available for this part.'
        );
        const descriptionWrap = this.descriptionDialog.querySelector('[data-ed-dialog-description-wrap]');
        descriptionWrap.dataset.expanded = 'false';
        const readMore = this.descriptionDialog.querySelector('[data-ed-dialog-read-more]');
        readMore.hidden = descriptionText.length < 240 && !part.descriptionHtml;
        readMore.textContent = 'Read more';
        readMore.setAttribute('aria-expanded', 'false');
        const fitment = this.descriptionDialog.querySelector('[data-ed-dialog-fitment]');
        fitment.textContent = part.fitment;
        fitment.hidden = !part.fitment;
        const link = this.descriptionDialog.querySelector('[data-ed-dialog-product-link]');
        link.hidden = productUrl === '#';
        link.href = productUrl;
        const stock = this.descriptionDialog.querySelector('[data-ed-dialog-stock]');
        stock.replaceChildren(this.createAvailability(
          part.orderState?.state || (part.productHandle ? 'checking' : 'not_found'),
          part.orderState?.label || (part.productHandle ? 'Checking stock…' : 'Product not found')
        ));
        this.renderDialogPrice(part);
        const dialogOrder = this.descriptionDialog.querySelector('[data-ed-dialog-order]');
        const rowQuantity = this.rows
          .find((row) => row._explodedDiagramPart === part)
          ?.querySelector('input[name="quantity"]')?.value || 1;
        const dialogForm = this.createOrderForm(part, {
          context: 'dialog',
          quantity: rowQuantity
        });
        dialogOrder.replaceChildren(dialogForm);
        this.configureOrderForm(dialogForm, part.orderState || {
          state: part.productHandle ? 'checking' : 'not_found',
          label: part.productHandle ? 'Checking stock…' : 'Product not found',
          enabled: false,
          variantId: ''
        });
        this.syncPartListActions(part);
        if (!this.descriptionDialog.open) this.descriptionDialog.showModal();
        this.lockPageScroll();
      }

      refreshOpenDialogIdentity(part) {
        if (this.activeDialogPart !== part || !this.descriptionDialog) return;
        this.descriptionDialog.querySelector('[data-ed-dialog-product-title]').textContent =
          part.productTitle || part.title || 'Product details';
        const catalogueTitle = this.descriptionDialog.querySelector('[data-ed-dialog-catalogue-title]');
        catalogueTitle.textContent = part.title && part.title !== part.productTitle
          ? `Catalogue description: ${part.title}`
          : '';
        catalogueTitle.hidden = !catalogueTitle.textContent;
        const sku = this.descriptionDialog.querySelector('[data-ed-dialog-sku]');
        sku.textContent = part.sku ? `SKU: ${part.sku}` : '';
        sku.hidden = !part.sku;
        const imageWrap = this.descriptionDialog.querySelector('[data-ed-dialog-image-wrap]');
        const image = this.descriptionDialog.querySelector('[data-ed-dialog-image]');
        imageWrap.hidden = !part.imageUrl;
        if (part.imageUrl) {
          image.src = part.imageUrl;
          image.alt = part.productTitle || part.title || 'Product image';
        }
        const productUrl = this.safeProductUrl(part, part.resolvedVariantId);
        const link = this.descriptionDialog.querySelector('[data-ed-dialog-product-link]');
        link.hidden = productUrl === '#';
        link.href = productUrl;
        this.renderProductDescription(
          this.descriptionDialog.querySelector('[data-ed-dialog-description]'),
          part,
          'No extended description is available for this part.'
        );
        const refreshedDescriptionText = part.description || '';
        const refreshedReadMore = this.descriptionDialog.querySelector('[data-ed-dialog-read-more]');
        refreshedReadMore.hidden = refreshedDescriptionText.length < 240 && !part.descriptionHtml;
      }

      closeDescription() {
        if (!this.descriptionDialog?.open) return;
        this.descriptionDialog.close();
        this.activeDialogPart = null;
        this.unlockPageScroll();
      }

      toggleDialogDescription() {
        const wrap = this.descriptionDialog?.querySelector('[data-ed-dialog-description-wrap]');
        const button = this.descriptionDialog?.querySelector('[data-ed-dialog-read-more]');
        if (!wrap || !button) return;
        const expanded = wrap.dataset.expanded !== 'true';
        wrap.dataset.expanded = String(expanded);
        button.textContent = expanded ? 'Show less' : 'Read more';
        button.setAttribute('aria-expanded', String(expanded));
      }

      lockPageScroll() {
        if (this.dialogScrollLocked) return;
        this.dialogScrollLocked = true;
        this.dialogPreviousRootOverflow = document.documentElement.style.overflow;
        this.dialogPreviousBodyOverflow = document.body.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
      }

      unlockPageScroll() {
        if (!this.dialogScrollLocked) return;
        document.documentElement.style.overflow = this.dialogPreviousRootOverflow || '';
        document.body.style.overflow = this.dialogPreviousBodyOverflow || '';
        this.dialogPreviousRootOverflow = null;
        this.dialogPreviousBodyOverflow = null;
        this.dialogScrollLocked = false;
      }

      addPartToList(index) {
        const part = this.parts.find((item) => item.index === index);
        const row = this.rows.find((item) => item._explodedDiagramPart === part);
        if (!part || !row) return false;
        const quantity = Math.max(
          1,
          Math.floor(Number(row.querySelector('input[name="quantity"]')?.value) || 1)
        );
        this.partsList.set(index, { part, quantity });
        this.updateListSummary();
        this.announce(`${part.title} added to list with quantity ${quantity}`);
        this.showToast(part, 'list');
        return true;
      }

      removePartFromList(index) {
        const entry = this.partsList.get(index);
        this.partsList.delete(index);
        const row = this.rows.find((item) => Number(item.dataset.partKey) === index);
        const removeButton = row?.querySelector('[data-ed-remove-list]');
        if (removeButton) removeButton.hidden = true;
        if (this.listMode && this.partsList.size === 0) this.listMode = false;
        this.dataset.listMode = String(this.listMode);
        this.updateListSummary();
        this.applyFilters();
        if (entry) this.announce(`${entry.part.title} removed from list`);
      }

      syncPartListActions(targetPart = null) {
        const parts = targetPart ? [targetPart] : this.parts;
        parts.forEach((part) => {
          const listed = this.partsList.has(part.index);
          this.querySelectorAll(`[data-ed-add-list="${part.index}"]`).forEach((button) => {
            button.textContent = listed ? 'In list' : '+ List';
            button.setAttribute(
              'aria-label',
              listed
                ? `${part.productTitle || part.title} is in the parts list`
                : `Add ${part.productTitle || part.title} to parts list`
            );
            button.disabled = listed;
            button.hidden = button.dataset.edListContext === 'row' && listed;
          });
          const row = this.rows.find((item) => item._explodedDiagramPart === part);
          const removeButton = row?.querySelector('[data-ed-remove-list]');
          if (removeButton) removeButton.hidden = !listed;
        });
      }

      updateListSummary() {
        const entries = [...this.partsList.values()];
        const totalQuantity = entries.reduce((total, entry) => total + entry.quantity, 0);
        if (this.listCount) this.listCount.textContent = String(this.partsList.size);
        if (this.listSummary) this.listSummary.hidden = this.partsList.size === 0;
        if (this.viewListButton) this.viewListButton.textContent = this.listMode ? 'View all parts' : 'View list';
        this.addListCartButtons.forEach((button) => {
          button.disabled = this.partsList.size === 0;
        });
        if (this.listFooter) this.listFooter.hidden = !this.listMode || this.partsList.size === 0;
        if (this.listQuantity) this.listQuantity.textContent = String(totalQuantity);
        const pricesReady = entries.every((entry) => Number.isFinite(entry.part.priceCents));
        if (this.listPrice) {
          this.listPrice.textContent = pricesReady
            ? this.formatMoney(entries.reduce((total, entry) => total + (entry.part.priceCents * entry.quantity), 0))
            : 'Pending';
        }
        const unavailable = entries.filter((entry) =>
          ['out_of_stock', 'not_found'].includes(entry.part.orderState?.state)
        );
        if (this.listWarning) this.listWarning.hidden = unavailable.length === 0;
        if (this.listWarningText) {
          this.listWarningText.textContent = unavailable.length
            ? `${unavailable.length} list item${unavailable.length === 1 ? ' is' : 's are'} out of stock or unavailable`
            : '';
        }
        this.syncPartListActions();
      }

      toggleListView() {
        if (!this.partsList.size) return;
        this.listMode = !this.listMode;
        this.dataset.listMode = String(this.listMode);
        if (this.search) this.search.value = '';
        this.updateListSummary();
        this.applyFilters();
        this.tableScroll?.scrollTo({ top: 0, behavior: 'auto' });
      }

      showListView() {
        if (!this.partsList.size) return;
        this.listMode = true;
        this.dataset.listMode = 'true';
        if (this.search) this.search.value = '';
        this.updateListSummary();
        this.applyFilters();
        this.tableScroll?.scrollTo({ top: 0, behavior: 'smooth' });
        this.partsPane?.scrollIntoView({
          block: 'start',
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      }

      clearPartsList() {
        if (!this.partsList.size) return;
        this.partsList.clear();
        this.listMode = false;
        this.dataset.listMode = 'false';
        this.updateListSummary();
        this.applyFilters();
        this.tableScroll?.scrollTo({ top: 0, behavior: 'auto' });
        this.announce('Parts list cleared');
      }

      async addListToCart(button) {
        this.setListMessage('');
        const allEntries = [...this.partsList.values()];
        const entries = allEntries.filter((entry) =>
          entry.part.orderState?.enabled && entry.part.resolvedVariantId
        );
        if (!entries.length) {
          const message = 'No available list items can be added. Remove or review the unavailable products shown above.';
          this.setListMessage(message, 'error');
          this.announce(message);
          return;
        }
        const grouped = new Map();
        entries.forEach((entry) => {
          const id = Number(entry.part.resolvedVariantId);
          const current = grouped.get(id) || { id, quantity: 0, entries: [] };
          current.quantity += entry.quantity;
          current.entries.push(entry);
          grouped.set(id, current);
        });
        const items = [...grouped.values()].map(({ id, quantity }) => ({ id, quantity }));
        const skipped = allEntries.length - entries.length;
        const message = skipped > 0
          ? `Available list items added to cart; ${skipped} unavailable item${skipped === 1 ? '' : 's'} skipped`
          : 'List added to cart';
        const totalPrice = entries.every((entry) => Number.isFinite(entry.part.priceCents))
          ? entries.reduce((total, entry) => total + (entry.part.priceCents * entry.quantity), 0)
          : null;
        const added = await this.submitCartItems(items, button, message, {
          title: `${entries.length} product${entries.length === 1 ? '' : 's'} from your list`,
          sku: '',
          priceCents: totalPrice,
          snapshotPrice: ''
        });
        if (added) {
          this.removeAddedListEntries(entries);
          this.setListMessage(skipped > 0 ? message : '');
          return;
        }

        this.setListMessage('The batch was rejected by Shopify. Checking each item so valid products can still be added…');
        const retry = await this.retryListItemsIndividually([...grouped.values()], button);
        const successfulEntries = retry.successful.flatMap((item) => item.entries);
        if (successfulEntries.length) this.removeAddedListEntries(successfulEntries);

        if (retry.failed.length) {
          const failures = retry.failed
            .map((item) => {
              const references = item.entries.map((entry) => `Ref. ${entry.part.reference}`).join(', ');
              return `${references}: ${item.error}`;
            })
            .join(' ');
          const retryMessage = successfulEntries.length
            ? `${successfulEntries.length} product${successfulEntries.length === 1 ? '' : 's'} added. ${retry.failed.length} could not be added — ${failures}`
            : `No products were added — ${failures}`;
          this.setListMessage(retryMessage, 'error');
          this.announce(retryMessage);
        } else {
          const retryMessage = `${successfulEntries.length} list product${successfulEntries.length === 1 ? '' : 's'} added to cart`;
          this.setListMessage('');
          this.announce(retryMessage);
        }
      }

      setListMessage(message, tone = 'info') {
        if (!this.listMessage) return;
        this.listMessage.textContent = message;
        this.listMessage.hidden = !message;
        this.listMessage.dataset.tone = tone;
      }

      removeAddedListEntries(entries) {
        entries.forEach((entry) => this.partsList.delete(entry.part.index));
        if (this.partsList.size === 0) {
          this.listMode = false;
          this.dataset.listMode = 'false';
        }
        this.updateListSummary();
        this.applyFilters();
      }

      async retryListItemsIndividually(groupedItems, button) {
        const successful = [];
        const failed = [];
        const label = button.querySelector?.('[data-ed-button-label]') || button;
        const originalLabel = 'Add list items to cart';
        window.clearTimeout(button._edLabelTimer);
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        label.textContent = 'Checking items…';
        let latestResult = null;

        for (const [index, item] of groupedItems.entries()) {
          try {
            latestResult = await this.postCartItems([{ id: item.id, quantity: item.quantity }]);
            successful.push(item);
          } catch (error) {
            failed.push({
              ...item,
              error: error.message || this.dataset.cartError
            });
          }
          if (index < groupedItems.length - 1) {
            await new Promise((resolve) => window.setTimeout(resolve, 100));
          }
        }

        try {
          const cart = await this.fetchCartState().catch(() => null);
          if (latestResult) {
            const nativeSync = this.syncNativeCartDrawer(latestResult, cart);
            if (!nativeSync.rendered) {
              const horizonSync = await this.syncHorizonCartDrawer(latestResult);
              if (!horizonSync.rendered) await this.renderCartSections(latestResult);
            }
          }
          if (!latestResult || !(await this.refreshCartMarkupFallback())) {
            this.syncCartDrawerState(cart);
          }
          await this.refreshCartCount(cart);
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        } finally {
          button.removeAttribute('aria-busy');
          button.disabled = this.partsList.size === 0;
          label.textContent = failed.length ? 'Some items could not be added' : 'Items added';
          button._edLabelTimer = window.setTimeout(() => {
            label.textContent = originalLabel;
          }, 2400);
        }
        return { successful, failed };
      }

      scheduleProductHydration() {
        const start = () => {
          this.hydrationIdleTask = null;
          this.hydrationTimer = null;
          if (this.isConnected) this.startProductHydration();
        };
        if ('requestIdleCallback' in window) {
          this.hydrationIdleTask = window.requestIdleCallback(start, { timeout: 800 });
        } else {
          this.hydrationTimer = window.setTimeout(start, 120);
        }
      }

      startProductHydration() {
        const linkedRows = this.rows.filter((row) => row._explodedDiagramPart.productHandle);
        if (!linkedRows.length) return;

        if ('IntersectionObserver' in window) {
          this.rowObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              const handle = entry.target._explodedDiagramPart?.productHandle;
              if (handle) this.queueProduct(handle);
              this.rowObserver.unobserve(entry.target);
            });
          }, {
            root: this.tableScroll,
            rootMargin: '120px 0px',
            threshold: 0
          });
          linkedRows.forEach((row) => this.rowObserver.observe(row));
        } else {
          linkedRows.forEach((row) => this.queueProduct(row._explodedDiagramPart.productHandle));
        }
      }

      queueProduct(handle) {
        if (!handle || this.queuedHandles.has(handle) || this.productCache.has(handle)) return;
        this.queuedHandles.add(handle);
        this.productQueue.push(handle);
        this.runProductQueue();
      }

      runProductQueue() {
        while (this.activeProductRequests < this.maximumProductRequests && this.productQueue.length) {
          const handle = this.productQueue.shift();
          this.activeProductRequests += 1;
          this.fetchProduct(handle)
            .catch(() => null)
            .finally(() => {
              this.activeProductRequests -= 1;
              this.runProductQueue();
            });
        }
      }

      async fetchProduct(handle) {
        const productUrl = `${this.dataset.productsRoot}${encodeURIComponent(handle)}.js`;
        try {
          const response = await fetch(productUrl, {
            headers: { Accept: 'application/json' },
            credentials: 'same-origin'
          });
          if (!response.ok) throw new Error(`HTTP ${response.status}`);
          const product = await response.json();
          this.productCache.set(handle, product);
          this.rows
            .filter((row) => row._explodedDiagramPart.productHandle === handle)
            .forEach((row) => this.applyProduct(row, product));
        } catch (error) {
          this.productCache.set(handle, null);
          this.rows
            .filter((row) => row._explodedDiagramPart.productHandle === handle)
            .forEach((row) => this.setRowUnavailable(row, 'Product not found'));
          throw error;
        }
      }

      applyProduct(row, product) {
        const part = row._explodedDiagramPart;
        const variants = Array.isArray(product.variants) ? product.variants : [];
        let variant = null;
        if (part.variantId) {
          variant = variants.find((item) => String(item.id) === part.variantId);
        }
        if (!variant && part.variantSku) {
          const wantedSku = part.variantSku.trim().toLocaleUpperCase();
          variant = variants.find((item) => String(item.sku || '').trim().toLocaleUpperCase() === wantedSku);
        }
        if (!variant && variants.length === 1) variant = variants[0];
        if (!variant) {
          this.setRowUnavailable(row, 'Product not found');
          return;
        }

        part.resolvedVariantId = String(variant.id);
        part.productTitle = product.title || variant.name || part.title || 'Untitled part';
        part.title = part.title || part.productTitle;
        part.sku = part.sku || variant.sku || '';
        part.productDescriptionHtml = String(product.description || '');
        if (product._explodedDiagramDescriptionText === undefined) {
          product._explodedDiagramDescriptionText = this.stripHtml(part.productDescriptionHtml);
        }
        part.description = product._explodedDiagramDescriptionText || part.description;
        part.productUrl = this.safeProductUrl(part, part.resolvedVariantId);
        part.imageUrl = this.safeImageUrl(
          variant.featured_image?.src || variant.featured_image || product.featured_image || product.images?.[0]
        );
        part.priceCents = Number(variant.price) || 0;
        part.compareAtPriceCents = Number(variant.compare_at_price) || 0;

        const title = row.querySelector('[data-ed-part-title]');
        const catalogueTitle = title.querySelector('[data-ed-catalogue-title]');
        const titleSeparator = title.querySelector('[data-ed-title-separator]');
        const shopifyTitle = title.querySelector('[data-ed-shopify-title]');
        const hasDistinctShopifyTitle = Boolean(part.productTitle && part.productTitle !== part.title);
        catalogueTitle.textContent = part.title || part.productTitle;
        titleSeparator.hidden = !hasDistinctShopifyTitle;
        shopifyTitle.textContent = hasDistinctShopifyTitle ? part.productTitle : '';
        shopifyTitle.hidden = !hasDistinctShopifyTitle;
        title.title = hasDistinctShopifyTitle
          ? `${part.title} — ${part.productTitle}`
          : part.productTitle || part.title;
        row.querySelector('[data-ed-open-product]')?.setAttribute(
          'aria-label',
          `Open product details for ${part.productTitle || part.title}`
        );
        const sku = row.querySelector('[data-ed-part-sku]');
        sku.textContent = part.sku ? `SKU: ${part.sku}` : '';
        sku.hidden = !part.sku;
        const description = row.querySelector('[data-ed-part-description]');
        description.textContent = part.description;
        description.hidden = !part.description;
        description.setAttribute('aria-label', `Read full description for ${part.productTitle || part.title}`);

        const price = row.querySelector('[data-ed-price]');
        price.replaceChildren();
        const compareAt = part.compareAtPriceCents;
        const currentPrice = part.priceCents;
        if (compareAt > currentPrice) {
          const oldPrice = document.createElement('s');
          oldPrice.textContent = this.formatMoney(compareAt);
          price.append(oldPrice);
        }
        const livePrice = document.createElement('strong');
        livePrice.textContent = this.formatMoney(currentPrice);
        price.append(livePrice);

        const stockSnapshot = this.stockSnapshotState(part.snapshotStock);
        const canOrder = Boolean(variant.available) && stockSnapshot !== 'out_of_stock';
        const stockLabel = !variant.available
          ? 'Out of stock'
          : stockSnapshot === 'out_of_stock'
            ? 'Out of stock (schedule)'
            : stockSnapshot === 'low_stock'
              ? 'Low stock'
              : stockSnapshot === 'in_stock'
              ? 'In stock'
              : 'In stock';
        this.setOrderState(row, {
          state: !canOrder ? 'out_of_stock' : stockSnapshot === 'low_stock' ? 'low_stock' : 'in_stock',
          label: stockLabel,
          enabled: canOrder,
          variantId: part.resolvedVariantId
        });
        if (this.activeSelectedPart === part) this.renderQuickPreview(part);
        if (this.activeDialogPart === part) this.refreshOpenDialogIdentity(part);
        this.updateRowSearch(row);
      }

      stockSnapshotState(value) {
        const normalized = this.normalize(value).trim();
        if (!normalized) return null;
        if (['false', 'no', '0', 'out of stock', 'sold out', 'unavailable'].includes(normalized)) return 'out_of_stock';
        if (['low stock', 'low', 'limited'].includes(normalized)) return 'low_stock';
        if (['true', 'yes', '1', 'in stock', 'available'].includes(normalized)) return 'in_stock';
        return null;
      }

      renderDialogPrice(part) {
        const price = this.descriptionDialog?.querySelector('[data-ed-dialog-price]');
        this.renderPrice(price, part);
      }

      renderPrice(price, part) {
        if (!price || !part) return;
        price.replaceChildren();
        if (part.compareAtPriceCents > part.priceCents) {
          const oldPrice = document.createElement('s');
          oldPrice.textContent = this.formatMoney(part.compareAtPriceCents);
          price.append(oldPrice);
        }
        if (Number.isFinite(part.priceCents)) {
          const currentPrice = document.createElement('strong');
          currentPrice.textContent = this.formatMoney(part.priceCents);
          price.append(currentPrice);
        } else if (part.snapshotPrice) {
          const fallbackPrice = document.createElement('strong');
          fallbackPrice.textContent = part.snapshotPrice;
          price.append(fallbackPrice);
        } else {
          price.textContent = 'Price unavailable';
        }
      }

      stripHtml(value) {
        const parser = document.createElement('div');
        parser.innerHTML = String(value || '');
        return parser.textContent.replace(/\s+/g, ' ').trim();
      }

      sanitizeProductDescription(value) {
        const template = document.createElement('template');
        template.innerHTML = String(value || '');
        template.content
          .querySelectorAll('script, style, template, noscript, iframe, object, embed, form, input, button')
          .forEach((element) => element.remove());
        const allowedElements = new Set([
          'A', 'B', 'BLOCKQUOTE', 'BR', 'CAPTION', 'CODE', 'COL', 'COLGROUP', 'DD', 'DEL', 'DETAILS',
          'DIV', 'DL', 'DT', 'EM', 'FIGCAPTION', 'FIGURE', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'HR',
          'I', 'IMG', 'LI', 'MARK', 'OL', 'P', 'PRE', 'S', 'SMALL', 'SPAN', 'STRONG', 'SUB', 'SUMMARY',
          'SUP', 'TABLE', 'TBODY', 'TD', 'TFOOT', 'TH', 'THEAD', 'TR', 'U', 'UL'
        ]);
        const elements = [...template.content.querySelectorAll('*')];
        elements.forEach((element) => {
          if (!allowedElements.has(element.tagName)) {
            element.replaceWith(...element.childNodes);
            return;
          }
          const retained = new Set(['class']);
          if (element.tagName === 'A') retained.add('href');
          if (element.tagName === 'A') retained.add('target');
          if (element.tagName === 'IMG') {
            ['src', 'alt', 'width', 'height'].forEach((name) => retained.add(name));
          }
          if (['TD', 'TH'].includes(element.tagName)) {
            ['colspan', 'rowspan', 'scope'].forEach((name) => retained.add(name));
          }
          [...element.attributes].forEach((attribute) => {
            if (!retained.has(attribute.name.toLowerCase())) element.removeAttribute(attribute.name);
          });
          if (element.tagName === 'A') {
            const href = element.getAttribute('href') || '';
            try {
              const url = new URL(href, window.location.origin);
              if (!['http:', 'https:', 'mailto:', 'tel:'].includes(url.protocol)) element.removeAttribute('href');
            } catch {
              element.removeAttribute('href');
            }
            if (element.getAttribute('target') === '_blank') {
              element.setAttribute('rel', 'noopener');
            } else {
              element.removeAttribute('target');
            }
          }
          if (element.tagName === 'IMG') {
            const source = this.safeImageUrl(element.getAttribute('src'));
            if (!source) {
              element.remove();
              return;
            }
            element.src = source;
            element.loading = 'lazy';
            element.decoding = 'async';
          }
        });
        return template.innerHTML.trim();
      }

      renderProductDescription(container, part, fallback) {
        if (!container) return;
        if (!part?.descriptionHtml && part?.productDescriptionHtml) {
          const key = part.productHandle || part.productUrl || String(part.index);
          if (!this.descriptionHtmlCache.has(key)) {
            this.descriptionHtmlCache.set(
              key,
              this.sanitizeProductDescription(part.productDescriptionHtml)
            );
          }
          part.descriptionHtml = this.descriptionHtmlCache.get(key);
        }
        if (part?.descriptionHtml) {
          container.innerHTML = part.descriptionHtml;
          return;
        }
        container.textContent = part?.description || fallback;
      }

      formatMoney(cents) {
        const currency = this.dataset.currencyCode || 'GBP';
        try {
          return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
            style: 'currency',
            currency
          }).format(Number(cents) / 100);
        } catch {
          return `${currency} ${(Number(cents) / 100).toFixed(2)}`;
        }
      }

      setRowUnavailable(row, label) {
        const price = row.querySelector('[data-ed-price]');
        const part = row._explodedDiagramPart;
        price.textContent = part.snapshotPrice || '—';
        this.setOrderState(row, {
          state: 'not_found',
          label,
          enabled: false,
          variantId: ''
        });
      }

      setOrderState(row, { state, label, enabled, variantId }) {
        const part = row._explodedDiagramPart;
        part.orderState = { state, label, enabled, variantId };
        const form = row.querySelector('[data-ed-add-form]');
        this.configureOrderForm(form, part.orderState);
        this.syncPartListActions(part);
        if (this.partsList.has(part.index)) this.updateListSummary();
        if (this.activeSelectedPart === part) this.renderQuickPreview(part);
        if (this.activeDialogPart === part) {
          const dialogForm = this.descriptionDialog?.querySelector('[data-ed-dialog-order] [data-ed-add-form]');
          if (dialogForm) this.configureOrderForm(dialogForm, part.orderState);
          const dialogStock = this.descriptionDialog?.querySelector('[data-ed-dialog-stock]');
          dialogStock?.replaceChildren(this.createAvailability(state, label));
          this.renderDialogPrice(part);
        }
      }

      configureOrderForm(form, { state, label, enabled, variantId }) {
        if (!form) return;
        const status = form.querySelector('[data-ed-order-status]');
        status.replaceChildren(this.createAvailability(state, label));
        const variantInput = form.querySelector('[data-ed-variant-id]');
        variantInput.value = variantId;
        const stepper = form.querySelector('[data-ed-quantity-stepper]');
        const controls = [...stepper.querySelectorAll('button, input')];
        controls.forEach((control) => {
          control.disabled = !enabled;
        });
        stepper.classList.toggle('exploded-diagram__quantity-stepper--disabled', !enabled);
        const addButton = form.querySelector('.exploded-diagram__add-button');
        addButton.disabled = !enabled;
        addButton.classList.toggle('exploded-diagram__add-button--disabled', !enabled);
        form.classList.toggle('exploded-diagram__add-form--disabled', !enabled);
      }

      setScale(nextScale, preserveCenter = true) {
        const clamped = Math.min(this.maximumScale, Math.max(this.minimumScale, nextScale));
        if (clamped === this.scale) return;
        if (clamped > this.minimumScale) this.loadHighResolutionDiagram();
        let centerX = 0.5;
        let centerY = 0.5;

        if (preserveCenter && this.surface.scrollWidth && this.surface.scrollHeight) {
          centerX = (this.surface.scrollLeft + (this.surface.clientWidth / 2)) / this.surface.scrollWidth;
          centerY = (this.surface.scrollTop + (this.surface.clientHeight / 2)) / this.surface.scrollHeight;
        }

        this.scale = clamped;
        this.updateScale(preserveCenter, centerX, centerY);
      }

      updateScale(preserveCenter, centerX = 0.5, centerY = 0.5, announce = true) {
        this.viewport?.style.setProperty('--ed-scale', String(this.scale));
        if (this.surface) this.surface.dataset.zoomed = String(this.scale > this.minimumScale);
        const percentage = Math.round(this.scale * 100);
        if (this.zoomOutput) this.zoomOutput.value = `${percentage}%`;
        if (this.zoomIn) this.zoomIn.disabled = this.scale >= this.maximumScale;
        if (this.zoomOut) this.zoomOut.disabled = this.scale <= this.minimumScale;
        if (announce) this.announce(this.dataset.zoomTemplate.replace('__ZOOM__', String(percentage)));

        if (preserveCenter && this.surface) {
          requestAnimationFrame(() => {
            this.surface.scrollLeft = (this.surface.scrollWidth * centerX) - (this.surface.clientWidth / 2);
            this.surface.scrollTop = (this.surface.scrollHeight * centerY) - (this.surface.clientHeight / 2);
          });
        }
      }

      scheduleZoomAnnouncement() {
        window.clearTimeout(this.zoomAnnouncementTimer);
        this.zoomAnnouncementTimer = window.setTimeout(() => {
          const percentage = Math.round(this.scale * 100);
          this.announce(this.dataset.zoomTemplate.replace('__ZOOM__', String(percentage)));
        }, 220);
      }

      containScheduleScroll(event) {
        if (!this.tableScroll || Math.abs(event.deltaY) < 0.01) return;
        const atTop = this.tableScroll.scrollTop <= 0;
        const atBottom =
          this.tableScroll.scrollTop + this.tableScroll.clientHeight >= this.tableScroll.scrollHeight - 1;
        if ((event.deltaY < 0 && atTop) || (event.deltaY > 0 && atBottom)) {
          event.preventDefault();
        }
      }

      zoomWithWheel(event) {
        if (!this.surface || !this.viewport) return;
        if (Math.abs(event.deltaY) < 0.01) return;
        let delta = event.deltaY;
        if (event.deltaMode === WheelEvent.DOM_DELTA_LINE) delta *= 16;
        if (event.deltaMode === WheelEvent.DOM_DELTA_PAGE) delta *= window.innerHeight;
        const atMinimum = this.scale <= this.minimumScale + 0.001;
        const atMaximum = this.scale >= this.maximumScale - 0.001;
        if (this.dataset.scheduleCollapsed === 'true' && atMinimum) return;
        if ((delta > 0 && atMinimum) || (delta < 0 && atMaximum)) return;
        event.preventDefault();
        this.wheelZoomDelta += delta;
        this.wheelZoomPoint = { x: event.clientX, y: event.clientY };
        if (this.wheelZoomFrame) return;

        this.wheelZoomFrame = requestAnimationFrame(() => {
          this.wheelZoomFrame = null;
          const accumulatedDelta = this.wheelZoomDelta;
          const pointer = this.wheelZoomPoint;
          this.wheelZoomDelta = 0;
          this.wheelZoomPoint = null;
          if (!pointer || !this.surface) return;
          const direction = accumulatedDelta < 0 ? 1 : -1;
          const magnitude = Math.min(0.24, Math.max(0.06, Math.abs(accumulatedDelta) * 0.0015));
          const nextScale = Math.min(
            this.maximumScale,
            Math.max(this.minimumScale, this.scale + (direction * magnitude))
          );
          if (nextScale === this.scale) return;
          const bounds = this.surface.getBoundingClientRect();
          const cursorX = pointer.x - bounds.left;
          const cursorY = pointer.y - bounds.top;
          const pointX = (this.surface.scrollLeft + cursorX) / Math.max(1, this.surface.scrollWidth);
          const pointY = (this.surface.scrollTop + cursorY) / Math.max(1, this.surface.scrollHeight);
          this.scale = nextScale;
          this.updateScale(false, 0.5, 0.5, false);
          this.surface.scrollLeft = (this.surface.scrollWidth * pointX) - cursorX;
          this.surface.scrollTop = (this.surface.scrollHeight * pointY) - cursorY;
          this.scheduleZoomAnnouncement();
        });
      }

      resetDiagram() {
        this.pinchState = null;
        this.pendingPinch = null;
        this.wheelZoomDelta = 0;
        this.wheelZoomPoint = null;
        if (this.wheelZoomFrame) cancelAnimationFrame(this.wheelZoomFrame);
        if (this.pinchFrame) cancelAnimationFrame(this.pinchFrame);
        this.wheelZoomFrame = null;
        this.pinchFrame = null;
        this.scale = 1;
        this.updateScale(false);
        this.surface?.scrollTo({ top: 0, left: 0, behavior: 'auto' });
        this.closeQuickPreview();
      }

      toggleSchedule() {
        this.setScheduleCollapsed(this.dataset.scheduleCollapsed !== 'true');
      }

      setScheduleCollapsed(collapsed) {
        if (!this.partsPane || !this.scheduleToggle) return;
        this.dataset.scheduleCollapsed = String(collapsed);
        this.partsPane.hidden = collapsed;
        this.scheduleToggle.setAttribute('aria-expanded', String(!collapsed));
        this.scheduleToggle.setAttribute('aria-label', collapsed ? 'Show parts schedule' : 'Hide parts schedule');
        if (this.scheduleToggleLabel) {
          this.scheduleToggleLabel.textContent = collapsed ? 'Show parts schedule' : 'Hide parts schedule';
        }
        this.announce(collapsed ? 'Parts schedule hidden' : 'Parts schedule shown');
      }

      async toggleFullscreen() {
        if (!this.fullscreenTarget) return;
        this.loadHighResolutionDiagram();

        if (this.diagramPane?.dataset.edFullscreenFallback === 'true') {
          this.exitFallbackFullscreen();
          return;
        }

        if (document.fullscreenElement === this.fullscreenTarget) {
          await document.exitFullscreen();
          return;
        }

        if (!this.fullscreenTarget.requestFullscreen || document.fullscreenEnabled === false) {
          this.enterFallbackFullscreen();
          return;
        }

        try {
          await this.fullscreenTarget.requestFullscreen();
        } catch {
          this.enterFallbackFullscreen();
        }
      }

      updateFullscreenState() {
        if (!this.fullscreenButton) return;
        const isFullscreen = document.fullscreenElement === this.fullscreenTarget
          || this.diagramPane?.dataset.edFullscreenFallback === 'true';
        const label = isFullscreen ? 'Exit diagram full screen' : 'Open diagram full screen';
        this.fullscreenButton.setAttribute('aria-pressed', String(isFullscreen));
        this.fullscreenButton.setAttribute('aria-label', label);
        this.fullscreenButton.title = isFullscreen ? 'Exit full screen' : 'Full screen';
      }

      enterFallbackFullscreen() {
        if (!this.diagramPane) return;
        this.previousRootOverflow = document.documentElement.style.overflow;
        this.previousBodyOverflow = document.body.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
        this.diagramPane.dataset.edFullscreenFallback = 'true';
        this.updateFullscreenState();
        this.fullscreenButton?.focus({ preventScroll: true });
      }

      exitFallbackFullscreen() {
        if (this.diagramPane?.dataset.edFullscreenFallback !== 'true') return;
        delete this.diagramPane.dataset.edFullscreenFallback;
        document.documentElement.style.overflow = this.previousRootOverflow || '';
        document.body.style.overflow = this.previousBodyOverflow || '';
        this.previousRootOverflow = null;
        this.previousBodyOverflow = null;
        this.updateFullscreenState();
      }

      printDiagram() {
        this.loadHighResolutionDiagram();
        const diagram = this.querySelector('.exploded-diagram__image');
        const source = this.viewport?.dataset.edHiresSrc || diagram?.currentSrc || diagram?.src;
        if (!diagram || !source) return;

        this.cleanupPrintView();
        const printWindow = window.open('', '_blank', 'popup,width=1000,height=800');
        if (!printWindow) {
          this.announce('Allow pop-ups to print the diagram image.');
          return;
        }
        printWindow.opener = null;
        this.printView = printWindow;
        const printDocument = printWindow.document;
        printDocument.documentElement.lang = document.documentElement.lang || 'en';
        const viewport = printDocument.createElement('meta');
        viewport.name = 'viewport';
        viewport.content = 'width=device-width, initial-scale=1';
        printDocument.head.replaceChildren(viewport);
        printDocument.title = diagram.getAttribute('alt') || 'Exploded diagram';
        const style = printDocument.createElement('style');
        style.textContent = '@page { size: auto; margin: 10mm; } html, body { width: 100%; min-height: 100%; margin: 0; background: #fff; } body { display: grid; place-items: center; } img { display: block; width: auto; max-width: 100%; height: auto; max-height: 100vh; object-fit: contain; }';
        printDocument.head.append(style);
        printDocument.body.replaceChildren();
        const printImage = printDocument.createElement('img');
        printImage.src = source;
        printImage.alt = diagram.getAttribute('alt') || 'Exploded diagram';
        printDocument.body.append(printImage);
        let printStarted = false;
        const startPrint = () => {
          if (printStarted || printWindow.closed) return;
          printStarted = true;
          window.setTimeout(() => {
            printWindow.focus();
            printWindow.print();
          }, 100);
        };
        if (printImage.complete) {
          startPrint();
        } else {
          printImage.addEventListener('load', startPrint, { once: true });
          printImage.addEventListener('error', startPrint, { once: true });
        }
        printWindow.addEventListener('afterprint', () => this.cleanupPrintView(), { once: true });
        this.printCleanupTimer = window.setTimeout(() => this.cleanupPrintView(), 120000);
      }

      loadHighResolutionDiagram() {
        if (this.highResolutionLoaded || !this.diagramImage || !this.viewport) return;
        const source = this.viewport.dataset.edHiresSrc;
        if (!source) return;
        this.highResolutionLoaded = true;
        this.diagramImage.removeAttribute('srcset');
        this.diagramImage.removeAttribute('sizes');
        this.diagramImage.fetchPriority = 'high';
        this.diagramImage.src = source;
      }

      cleanupPrintView() {
        if (this.printCleanupTimer) {
          window.clearTimeout(this.printCleanupTimer);
          this.printCleanupTimer = null;
        }
        if (typeof this.printView?.remove === 'function') {
          this.printView.remove();
        } else if (this.printView && !this.printView.closed) {
          this.printView.close();
        }
        this.printView = null;
      }

      handleDiagramKeydown(event) {
        if (event.metaKey || event.ctrlKey || event.altKey) return;
        if (event.key === '+' || event.key === '=') {
          event.preventDefault();
          this.setScale(this.scale + this.scaleStep);
        } else if (event.key === '-' || event.key === '_') {
          event.preventDefault();
          this.setScale(this.scale - this.scaleStep);
        } else if (event.key === '0') {
          event.preventDefault();
          this.resetDiagram();
        }
      }

      startPinch(event) {
        if (!this.surface || event.touches.length !== 2) return;
        event.preventDefault();
        const first = event.touches[0];
        const second = event.touches[1];
        const bounds = this.surface.getBoundingClientRect();
        const centerX = ((first.clientX + second.clientX) / 2) - bounds.left;
        const centerY = ((first.clientY + second.clientY) / 2) - bounds.top;
        this.pinchState = {
          distance: Math.max(1, Math.hypot(second.clientX - first.clientX, second.clientY - first.clientY)),
          scale: this.scale,
          pointX: (this.surface.scrollLeft + centerX) / Math.max(1, this.surface.scrollWidth),
          pointY: (this.surface.scrollTop + centerY) / Math.max(1, this.surface.scrollHeight)
        };
        this.dragState = null;
        delete this.surface.dataset.dragging;
      }

      pinch(event) {
        if (!this.surface || !this.pinchState || event.touches.length !== 2) return;
        event.preventDefault();
        const first = event.touches[0];
        const second = event.touches[1];
        this.pendingPinch = {
          firstX: first.clientX,
          firstY: first.clientY,
          secondX: second.clientX,
          secondY: second.clientY
        };
        if (this.pinchFrame) return;
        this.pinchFrame = requestAnimationFrame(() => {
          this.pinchFrame = null;
          const pending = this.pendingPinch;
          this.pendingPinch = null;
          if (!pending || !this.pinchState || !this.surface) return;
          const distance = Math.max(
            1,
            Math.hypot(pending.secondX - pending.firstX, pending.secondY - pending.firstY)
          );
          const nextScale = Math.min(
            this.maximumScale,
            Math.max(this.minimumScale, this.pinchState.scale * (distance / this.pinchState.distance))
          );
          const bounds = this.surface.getBoundingClientRect();
          const centerX = ((pending.firstX + pending.secondX) / 2) - bounds.left;
          const centerY = ((pending.firstY + pending.secondY) / 2) - bounds.top;
          const pointX = this.pinchState.pointX;
          const pointY = this.pinchState.pointY;
          this.scale = nextScale;
          this.updateScale(false, 0.5, 0.5, false);
          this.surface.scrollLeft = (this.surface.scrollWidth * pointX) - centerX;
          this.surface.scrollTop = (this.surface.scrollHeight * pointY) - centerY;
          this.scheduleZoomAnnouncement();
        });
      }

      endPinch(event) {
        if (event.touches.length < 2) this.pinchState = null;
      }

      startDrag(event) {
        if (this.scale <= 1 || event.target.closest('button, a, input')) return;
        if (!event.isPrimary) return;
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        event.preventDefault();
        this.dragState = {
          pointerId: event.pointerId,
          x: event.clientX,
          y: event.clientY,
          left: this.surface.scrollLeft,
          top: this.surface.scrollTop
        };
        this.surface.setPointerCapture(event.pointerId);
        this.surface.dataset.dragging = 'true';
      }

      drag(event) {
        if (!this.dragState || event.pointerId !== this.dragState.pointerId) return;
        event.preventDefault();
        this.pendingDrag = { x: event.clientX, y: event.clientY };
        if (this.dragFrame) return;
        this.dragFrame = requestAnimationFrame(() => {
          this.dragFrame = null;
          const pending = this.pendingDrag;
          this.pendingDrag = null;
          if (!pending || !this.dragState || !this.surface) return;
          this.surface.scrollLeft = this.dragState.left - (pending.x - this.dragState.x);
          this.surface.scrollTop = this.dragState.top - (pending.y - this.dragState.y);
        });
      }

      endDrag(event) {
        if (!this.dragState || event.pointerId !== this.dragState.pointerId) return;
        if (this.dragFrame) cancelAnimationFrame(this.dragFrame);
        this.dragFrame = null;
        this.pendingDrag = null;
        this.surface.releasePointerCapture?.(event.pointerId);
        delete this.surface.dataset.dragging;
        this.dragState = null;
      }

      async addToCart(form) {
        const button = form.querySelector('button[type="submit"]');
        const variantId = form.querySelector('[data-ed-variant-id]')?.value;
        const part = this.parts.find((item) => item.index === Number(form.dataset.edPartIndex));
        const quantity = Math.max(
          1,
          Math.floor(Number(form.querySelector('input[name="quantity"]')?.value) || 1)
        );
        if (!button || button.disabled || !variantId) return false;
        const added = await this.submitCartItems(
          [{ id: Number(variantId), quantity }],
          button,
          this.dataset.cartAdded,
          part
        );
        if (added && form.dataset.edFormContext === 'dialog') this.closeDescription();
        return added;
      }

      async addSelectedPartToCart(button) {
        const index = Number(button.dataset.edPartIndex);
        const part = this.parts.find((item) => item.index === index) || this.activeSelectedPart;
        const row = this.rows.find((item) => item._explodedDiagramPart === part);
        if (!part?.orderState?.enabled || !part.resolvedVariantId || !row) return false;
        const quantity = Math.max(
          1,
          Math.floor(Number(row.querySelector('input[name="quantity"]')?.value) || 1)
        );
        const added = await this.submitCartItems(
          [{ id: Number(part.resolvedVariantId), quantity }],
          button,
          this.dataset.cartAdded,
          part
        );
        if (added) this.closeQuickPreview();
        return added;
      }

      async postCartItems(items) {
        const sectionIds = this.getCartSectionIds();
        const payload = {
          items,
          sections_url: `${window.location.pathname}${window.location.search}`
        };
        if (sectionIds.length) payload.sections = sectionIds.join(',');
        const response = await fetch(this.dataset.cartAddUrl, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify(payload),
          credentials: 'same-origin'
        });
        const result = await response.json().catch(() => ({}));
        if (!response.ok) {
          throw new Error(result.description || result.message || this.dataset.cartError);
        }
        return result;
      }

      async submitCartItems(items, button, successMessage, toastPart = null) {
        if (!items.length || !button || button.disabled) return false;
        const label = button.querySelector?.('[data-ed-button-label]') || button;
        const originalLabel = label.textContent;
        const quickPartIndex = button.matches?.('[data-ed-quick-add-cart]')
          ? button.dataset.edPartIndex
          : null;
        window.clearTimeout(button._edLabelTimer);
        const cartUpdate = this.createStandardCartUpdate(items);
        button.setAttribute('aria-busy', 'true');
        button.disabled = true;

        try {
          const result = await this.postCartItems(items);
          const cart = await this.fetchCartState().catch(() => null);
          const nativeSync = this.syncNativeCartDrawer(result, cart);
          const horizonSync = nativeSync.rendered
            ? { rendered: false, eventTarget: null }
            : await this.syncHorizonCartDrawer(result);
          const rendered = nativeSync.rendered || horizonSync.rendered || await this.renderCartSections(result);
          const addedQuantity = items.reduce((total, item) => total + item.quantity, 0);
          const visibleCartCount = Number(
            document.querySelector('[data-cart-count], .cart-count-bubble span[aria-hidden="true"]')?.textContent
          ) || 0;
          cartUpdate.resolve({
            cart: this.toStandardCart(cart),
            detail: {
              items: cart?.items || result.items || result,
              source: 'exploded-diagram',
              sourceId: this.id,
              itemCount: cart?.item_count ?? visibleCartCount + addedQuantity,
              sections: result.sections || {},
              didError: false
            }
          });
          if (!rendered) {
            await this.refreshCartMarkupFallback();
          }
          this.syncCartDrawerState(cart);
          cartUpdate.dispatch(horizonSync.eventTarget || this);
          label.textContent = successMessage;
          this.announce(successMessage);
          this.dispatchEvent(new CustomEvent('exploded-diagram:cart-add', {
            bubbles: true,
            detail: { items: cart?.items || result.items || result, cart }
          }));
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          await this.refreshCartCount(cart);
          this.publishThemeCartUpdate(result, cart);
          if (toastPart) this.showToast(toastPart, 'cart');
          return true;
        } catch (error) {
          cartUpdate.reject(error);
          this.lastCartError = error.message || this.dataset.cartError;
          if (quickPartIndex === null || button.dataset.edPartIndex === quickPartIndex) {
            label.textContent = this.dataset.cartFailed;
            if (quickPartIndex !== null) this.showQuickCartError(this.lastCartError);
          }
          this.announce(this.lastCartError);
          return false;
        } finally {
          if (quickPartIndex === null || button.dataset.edPartIndex === quickPartIndex) {
            button.removeAttribute('aria-busy');
            if (quickPartIndex === null) {
              button.disabled = false;
            } else {
              const activePart = this.parts.find((part) => String(part.index) === quickPartIndex);
              button.disabled = !activePart?.orderState?.enabled || !activePart.resolvedVariantId;
            }
            button._edLabelTimer = window.setTimeout(() => {
              if (quickPartIndex === null || button.dataset.edPartIndex === quickPartIndex) {
                label.textContent = originalLabel;
              }
            }, 1800);
          }
        }
      }

      getCartSectionIds() {
        const sectionIds = new Set();
        if (document.getElementById('shopify-section-cart-drawer-section')) {
          sectionIds.add('cart-drawer-section');
        }
        if (document.querySelector('cart-drawer')) {
          sectionIds.add('cart-drawer');
          sectionIds.add('cart-icon-bubble');
        }
        document.querySelectorAll('cart-items-component[data-section-id]').forEach((element) => {
          if (element.dataset.sectionId) sectionIds.add(element.dataset.sectionId);
        });
        document.querySelectorAll('cart-drawer, cart-notification').forEach((element) => {
          if (typeof element.getSectionsToRender !== 'function') return;
          element.getSectionsToRender().forEach((section) => {
            const id = section.section || section.id;
            if (id) sectionIds.add(id);
          });
        });
        return [...sectionIds]
          .filter((id) => /^[a-zA-Z0-9_-]+$/.test(id))
          .slice(0, 5);
      }

      createStandardCartUpdate(items) {
        let resolve;
        let reject;
        const promise = new Promise((promiseResolve, promiseReject) => {
          resolve = promiseResolve;
          reject = promiseReject;
        });
        promise.catch(() => null);
        const event = new Event('shopify:cart:lines-update', { bubbles: true });
        event.action = 'add';
        event.context = 'product';
        event.lines = items.map((item) => ({
          merchandiseId: String(item.id),
          quantity: Number(item.quantity) || 1
        }));
        event.promise = promise;
        return {
          resolve,
          reject,
          dispatch: (target) => (target || this).dispatchEvent(event)
        };
      }

      toStandardCart(cart) {
        if (!cart) return null;
        return {
          id: cart.token || '',
          totalQuantity: Number(cart.item_count) || 0,
          cost: {
            totalAmount: {
              amount: String((Number(cart.total_price) || 0) / 100),
              currencyCode: this.dataset.currencyCode || ''
            }
          },
          lines: (cart.items || []).map((item) => ({
            id: item.key || item.id,
            quantity: Number(item.quantity) || 0,
            cost: {
              totalAmount: {
                amount: String((Number(item.final_line_price ?? item.line_price) || 0) / 100),
                currencyCode: this.dataset.currencyCode || ''
              }
            }
          })),
          discountCodes: []
        };
      }

      syncNativeCartDrawer(result, cart) {
        const drawer = document.querySelector('cart-drawer');
        const sectionHtml = result.sections?.['cart-drawer'];
        if (!drawer || !sectionHtml) return { rendered: false };

        let rendered = false;
        if (typeof drawer.renderContents === 'function') {
          try {
            drawer.renderContents(result);
            rendered = true;
          } catch {
            rendered = false;
          }
        }

        if (!rendered) {
          const parsed = new DOMParser().parseFromString(sectionHtml, 'text/html');
          const incoming = parsed.querySelector('#CartDrawer');
          const live = drawer.querySelector('#CartDrawer');
          if (incoming && live) {
            live.replaceChildren(...incoming.childNodes);
            rendered = true;
          }
        }

        if (rendered) this.syncCartDrawerState(cart);
        return { rendered };
      }

      syncCartDrawerState(cart = null) {
        document.querySelectorAll('cart-drawer, cart-notification').forEach((drawer) => {
          const hasRenderedItems = Boolean(
            drawer.querySelector('.cart-item, [id^="CartDrawer-Item-"], cart-drawer-items .cart-item')
          );
          const hasItems = cart
            ? Number(cart.item_count) > 0
            : hasRenderedItems;
          drawer.classList.toggle('is-empty', !hasItems);
          drawer.querySelector('.drawer__inner')?.classList.toggle('is-empty', !hasItems);
          drawer.querySelector('cart-drawer-items')?.classList.toggle('is-empty', !hasItems);
        });
      }

      publishThemeCartUpdate(result, cart) {
        if (
          typeof publish !== 'function'
          || typeof PUB_SUB_EVENTS === 'undefined'
          || !PUB_SUB_EVENTS.cartUpdate
        ) return;
        try {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'exploded-diagram',
            cartData: {
              ...result,
              item_count: cart?.item_count,
              items: cart?.items || result.items
            }
          });
        } catch {
          return;
        }
      }

      openCartDrawer(trigger = null) {
        const drawer = document.querySelector('cart-drawer');
        this.syncCartDrawerState();
        if (typeof drawer?.open === 'function') {
          drawer.open(trigger || document.activeElement);
          return;
        }
        document.querySelector('#cart-icon-bubble, [data-cart-drawer-trigger]')?.click();
      }

      showToast(part, type) {
        if (!this.toast || !part) return;
        window.clearTimeout(this.toastTimer);
        window.clearTimeout(this.toastHideTimer);
        this.toast.querySelector('[data-ed-toast-status]').textContent =
          type === 'cart' ? 'Added to cart' : 'Added to your list';
        this.toast.querySelector('[data-ed-toast-title]').textContent =
          part.productTitle || part.title || 'Product';
        this.toast.querySelector('[data-ed-toast-sku]').textContent =
          part.sku ? `SKU: ${part.sku}` : '';
        const price = Number.isFinite(part.priceCents)
          ? this.formatMoney(part.priceCents)
          : (part.snapshotPrice || '');
        this.toast.querySelector('[data-ed-toast-price]').textContent = price;
        const action = this.toast.querySelector('[data-ed-toast-action]');
        action.dataset.edToastAction = type === 'cart' ? 'cart' : 'list';
        action.textContent = type === 'cart' ? 'View cart' : 'View list';
        this.toast.hidden = false;
        this.toast.dataset.state = 'entering';
        requestAnimationFrame(() => {
          this.toast.dataset.state = 'visible';
        });
        this.toastTimer = window.setTimeout(() => this.hideToast(), 3000);
      }

      hideToast() {
        if (!this.toast || this.toast.hidden) return;
        window.clearTimeout(this.toastTimer);
        window.clearTimeout(this.toastHideTimer);
        this.toast.dataset.state = 'leaving';
        this.toastHideTimer = window.setTimeout(() => {
          this.toast.hidden = true;
          this.toast.dataset.state = 'hidden';
        }, 240);
      }

      async renderCartSections(result) {
        let rendered = false;
        document.querySelectorAll('cart-drawer, cart-notification').forEach((element) => {
          if (typeof element.renderContents !== 'function') return;
          try {
            element.renderContents(result);
            rendered = true;
          } catch {
            return;
          }
        });
        if (!result.sections || document.querySelector('cart-items-component[data-section-id]')) {
          return rendered;
        }
        Object.entries(result.sections).forEach(([sectionId, html]) => {
          if (!html) return;
          const liveSection = document.getElementById(`shopify-section-${sectionId}`);
          if (!liveSection) return;
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const incomingSection = parsed.getElementById(`shopify-section-${sectionId}`)
            || parsed.querySelector('.shopify-section');
          if (!incomingSection) return;
          liveSection.replaceChildren(...incomingSection.childNodes);
          rendered = true;
        });
        return rendered;
      }

      async syncHorizonCartDrawer(result) {
        const liveComponent = document.querySelector(
          '#shopify-section-cart-drawer-section cart-drawer-component, #cart-drawer cart-drawer-component'
        );
        if (!liveComponent) return { rendered: false, eventTarget: null };

        let sectionHtml = result.sections?.['cart-drawer-section'] || '';
        if (!sectionHtml) {
          try {
            const sectionUrl = new URL(window.location.href);
            sectionUrl.searchParams.delete('sections');
            sectionUrl.searchParams.set('section_id', 'cart-drawer-section');
            const response = await fetch(sectionUrl, {
              headers: { Accept: 'text/html' },
              credentials: 'same-origin',
              cache: 'no-store'
            });
            if (response.ok) sectionHtml = await response.text();
          } catch {
            sectionHtml = '';
          }
        }
        if (!sectionHtml) return { rendered: false, eventTarget: null };

        const parsed = new DOMParser().parseFromString(sectionHtml, 'text/html');
        const incomingComponent = parsed.querySelector(
          '#shopify-section-cart-drawer-section cart-drawer-component, #cart-drawer cart-drawer-component, cart-drawer-component'
        );
        if (!incomingComponent) return { rendered: false, eventTarget: null };

        liveComponent.replaceChildren(...incomingComponent.childNodes);
        return {
          rendered: true,
          eventTarget: liveComponent.querySelector('cart-items-component[data-section-id]')
        };
      }

      async refreshCartMarkupFallback() {
        const selectors = [
          '#shopify-section-cart-drawer-section',
          '#cart-drawer',
          'cart-drawer',
          'cart-notification'
        ];
        const liveTarget = selectors
          .map((selector) => document.querySelector(selector))
          .find(Boolean);
        if (!liveTarget) return false;
        try {
          const response = await fetch(window.location.href, {
            headers: { Accept: 'text/html' },
            credentials: 'same-origin',
            cache: 'no-store'
          });
          if (!response.ok) return false;
          const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
          const selector = selectors.find((candidate) => liveTarget.matches(candidate));
          const incomingTarget = selector ? parsed.querySelector(selector) : null;
          if (!incomingTarget) return false;
          liveTarget.replaceChildren(...incomingTarget.childNodes);
          return true;
        } catch {
          return false;
        }
      }

      async fetchCartState() {
        const response = await fetch(`${this.dataset.cartUrl}.js`, {
          headers: { Accept: 'application/json' },
          credentials: 'same-origin',
          cache: 'no-store'
        });
        if (!response.ok) throw new Error(this.dataset.cartError);
        return response.json();
      }

      async refreshCartCount(existingCart = null) {
        try {
          const cart = existingCart || await this.fetchCartState();
          document.querySelectorAll('[data-cart-count], .cart-count-bubble span[aria-hidden="true"]').forEach((node) => {
            node.textContent = String(cart.item_count);
          });
          document.dispatchEvent(new CustomEvent('cart:updated', {
            bubbles: true,
            detail: { cart }
          }));
          return cart;
        } catch {
          return null;
        }
      }

      announce(message) {
        if (!this.liveRegion || !message) return;
        this.liveRegion.textContent = '';
        requestAnimationFrame(() => {
          this.liveRegion.textContent = message;
        });
      }
    }

    customElements.define('exploded-diagram-viewer', ExplodedDiagram);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('custom-accordion').then(() => {
    class FooterAccordion extends CustomAccordion {
      constructor() {
        super();
        this.wasDesktop = window.matchMedia('(min-width: 750px)').matches;
        this.updateOpenState();
        window.addEventListener('resizeend', this.updateOpenState.bind(this));
      }

      updateOpenState() {
        if (window.matchMedia('(min-width: 750px)').matches) {
          this.detailsElem.open = true;
          this.summaryElem.setAttribute('tabindex', '-1');
          this.summaryElem.classList.add('pointer-events-none');
          this.wasDesktop = true;
        } else if (this.wasDesktop) {
          this.detailsElem.open = false;
          this.summaryElem.removeAttribute('tabindex');
          this.summaryElem.classList.remove('pointer-events-none');
          this.wasDesktop = false;
        }
      }
    }

    customElements.define('footer-accordion', FooterAccordion);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-main"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBounds = {};

      this.setHeaderHeight();
      this.setHeaderHeightLive();

      window.addEventListener('resizeend', this.setHeaderHeight.bind(this));
      window.addEventListener('resizeend', this.setHeaderHeightLive.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.lastScrollTrigger = 0;
      this.scrollThreshold = 50;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.searchButton = this.querySelector('.header__icon--search');
      if (this.searchButton) {
        this.searchButton.addEventListener('click', this.searchButtonClick.bind(this));
      }

      this.createObserver();
    }

    searchButtonClick() {
      this.preventHide = true;
      requestAnimationFrame(() => { this.preventHide = false; });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    setHeaderHeightLive(event, zero) {
      document.documentElement.style.setProperty('--header-height-live', `${zero ? 0 : this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      requestAnimationFrame(() => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

        // Only trigger actions if the scroll has changed by at least the threshold value
        if (Math.abs(scrollTop - this.lastScrollTrigger) < this.scrollThreshold) return;

        const scrollDifference = scrollTop - this.currentScrollTop;
        // Handle scrolling classes based on 50px sensitivity
        if (scrollDifference > 50 && this.pauseScrollListen !== true) {
          // Scrolling down
          this.pauseScrollListen = true;
          this.header.classList.add('scrolling-down');
          this.header.classList.remove('scrolling-up');
          setTimeout(() => { this.pauseScrollListen = false; }, 320);
        } else if (scrollDifference < -50 && this.pauseScrollListen !== true) {
          // Scrolling up
          this.pauseScrollListen = true;
          this.header.classList.add('scrolling-up');
          this.header.classList.remove('scrolling-down');
          setTimeout(() => { this.pauseScrollListen = false; }, 320);
        }

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          // Main logic for scrolling down
          this.header.classList.add('scrolled-past-header');
          if (this.preventHide) return;
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          // Main logic for scrolling up
          this.header.classList.add('scrolled-past-header');
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= this.headerBounds.top) {
          // Reset at the top
          this.header.classList.remove('scrolled-past-header');
          this.header.classList.remove('scrolling-down');
          this.header.classList.remove('scrolling-up');
          requestAnimationFrame(this.reset.bind(this));
        }

        this.currentScrollTop = scrollTop;
        this.lastScrollTrigger = scrollTop; // Update the last scroll position that triggered an action
      });
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
      this.setHeaderHeightLive(null, true);
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.setHeaderHeightLive();
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  (() => {
    const menuDetails = document.getElementById('Details-menu-drawer-container');
    if (!menuDetails) return;

    const menuSummary = menuDetails.querySelector('summary.header__icon--menu');
    const menuDrawer = menuDetails.querySelector('#menu-drawer');
    const drawerScrollContainer = menuDrawer?.querySelector('.menu-drawer__navigation-container') || menuDrawer;
    if (!menuSummary || !menuDrawer || !drawerScrollContainer) return;

    let previousHtmlOverflow = '';
    let previousHtmlOverscrollBehavior = '';
    let previousBodyOverflow = '';
    let previousBodyTouchAction = '';
    let previousBodyPosition = '';
    let previousBodyTop = '';
    let previousBodyLeft = '';
    let previousBodyRight = '';
    let previousBodyWidth = '';
    let previousBodyOverscrollBehavior = '';
    let lockedScrollY = 0;
    let scrollLocked = false;
    let closeMenuTimer = 0;
    let touchStartY = 0;

    const syncMenuDrawerBounds = () => {
      const headerSection = menuDetails.closest('.header-wrapper') || document.querySelector('.header-wrapper') || document.querySelector('.section-header');
      const headerRect = headerSection ? headerSection.getBoundingClientRect() : null;
      const headerBottom = headerRect ? Math.max(headerRect.bottom, 0) : 0;
      const drawerGap = 8;
      const drawerTop = Math.ceil(headerBottom + drawerGap);
      const maxDrawerHeight = Math.max(window.innerHeight - drawerTop - drawerGap, 160);

      menuDrawer.style.setProperty('--header-main-drawer-top', `${drawerTop}px`);
      menuDrawer.style.setProperty('--header-main-drawer-max-height', `${maxDrawerHeight}px`);
    };

    const lockPageScroll = () => {
      if (scrollLocked) return;

      lockedScrollY = window.scrollY || window.pageYOffset || 0;
      previousHtmlOverflow = document.documentElement.style.overflow;
      previousHtmlOverscrollBehavior = document.documentElement.style.overscrollBehavior;
      previousBodyOverflow = document.body.style.overflow;
      previousBodyTouchAction = document.body.style.touchAction;
      previousBodyPosition = document.body.style.position;
      previousBodyTop = document.body.style.top;
      previousBodyLeft = document.body.style.left;
      previousBodyRight = document.body.style.right;
      previousBodyWidth = document.body.style.width;
      previousBodyOverscrollBehavior = document.body.style.overscrollBehavior;

      document.documentElement.style.overflow = 'hidden';
      document.documentElement.style.overscrollBehavior = 'none';
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.top = `-${lockedScrollY}px`;
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
      document.body.style.overscrollBehavior = 'none';
      document.body.classList.add('overflow-hidden');
      scrollLocked = true;
    };

    const unlockPageScroll = () => {
      if (!scrollLocked) return;

      document.documentElement.style.overflow = previousHtmlOverflow;
      document.documentElement.style.overscrollBehavior = previousHtmlOverscrollBehavior;
      document.body.style.overflow = previousBodyOverflow;
      document.body.style.touchAction = previousBodyTouchAction;
      document.body.style.position = previousBodyPosition;
      document.body.style.top = previousBodyTop;
      document.body.style.left = previousBodyLeft;
      document.body.style.right = previousBodyRight;
      document.body.style.width = previousBodyWidth;
      document.body.style.overscrollBehavior = previousBodyOverscrollBehavior;
      document.body.classList.remove('overflow-hidden');
      window.scrollTo(0, lockedScrollY);
      scrollLocked = false;
    };

    const closeMenuDrawer = () => {
      window.clearTimeout(closeMenuTimer);
      menuDetails.classList.remove('header-main-menu-closing');
      menuDetails.removeAttribute('open');
      unlockPageScroll();
    };

    const requestCloseMenuDrawer = () => {
      if (!menuDetails.hasAttribute('open') || menuDetails.classList.contains('header-main-menu-closing')) return;

      menuDetails.classList.add('header-main-menu-closing');
      closeMenuTimer = window.setTimeout(() => {
        closeMenuDrawer();
      }, 180);
    };

    menuDetails.addEventListener('toggle', () => {
      if (menuDetails.hasAttribute('open')) {
        window.clearTimeout(closeMenuTimer);
        menuDetails.classList.remove('header-main-menu-closing');
        lockPageScroll();
        syncMenuDrawerBounds();
        requestAnimationFrame(syncMenuDrawerBounds);
        window.setTimeout(syncMenuDrawerBounds, 40);
      } else {
        menuDetails.classList.remove('header-main-menu-closing');
        unlockPageScroll();
      }
    });

    menuSummary.addEventListener('click', (event) => {
      if (!menuDetails.hasAttribute('open')) return;

      event.preventDefault();
      requestCloseMenuDrawer();
    });

    document.addEventListener('pointerdown', (event) => {
      if (!menuDetails.hasAttribute('open')) return;
      if (menuDrawer.contains(event.target) || menuSummary.contains(event.target)) return;

      event.preventDefault();
      event.stopPropagation();
      requestCloseMenuDrawer();
    }, true);

    const getScrollableContainer = (startTarget) => {
      if (!(startTarget instanceof Element)) return drawerScrollContainer;

      let node = startTarget;
      while (node && node !== menuDrawer) {
        if (node instanceof HTMLElement) {
          const computedStyle = window.getComputedStyle(node);
          const canScrollY = /(auto|scroll|overlay)/.test(computedStyle.overflowY);
          if (canScrollY && node.scrollHeight > node.clientHeight + 1) {
            return node;
          }
        }
        node = node.parentElement;
      }

      if (drawerScrollContainer.scrollHeight > drawerScrollContainer.clientHeight + 1) {
        return drawerScrollContainer;
      }

      return null;
    };

    document.addEventListener('touchstart', (event) => {
      if (!menuDetails.hasAttribute('open')) return;
      touchStartY = event.touches[0]?.clientY || 0;
    }, { passive: true, capture: true });

    document.addEventListener('touchmove', (event) => {
      if (!menuDetails.hasAttribute('open')) return;

      const target = event.target;
      if (!menuDrawer.contains(target)) {
        event.preventDefault();
        return;
      }

      const scrollContainer = getScrollableContainer(target);
      if (!scrollContainer) {
        event.preventDefault();
        return;
      }

      const currentY = event.touches[0]?.clientY || touchStartY;
      const deltaY = currentY - touchStartY;
      const atTop = scrollContainer.scrollTop <= 0;
      const atBottom = Math.ceil(scrollContainer.scrollTop + scrollContainer.clientHeight) >= scrollContainer.scrollHeight;

      if ((atTop && deltaY > 0) || (atBottom && deltaY < 0)) {
        event.preventDefault();
      }

      touchStartY = currentY;
    }, { passive: false, capture: true });

    document.addEventListener('wheel', (event) => {
      if (!menuDetails.hasAttribute('open')) return;
      if (menuDrawer.contains(event.target)) return;

      event.preventDefault();
    }, { passive: false, capture: true });

    window.addEventListener('resize', () => {
      if (!menuDetails.hasAttribute('open')) return;
      syncMenuDrawerBounds();
    });

    window.addEventListener('scroll', () => {
      if (!menuDetails.hasAttribute('open')) return;
      syncMenuDrawerBounds();
    }, { passive: true });

    window.addEventListener('pagehide', unlockPageScroll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-trade"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBounds = {};

      this.setHeaderHeight();
      this.setHeaderHeightLive();

      window.addEventListener('resizeend', this.setHeaderHeight.bind(this));
      window.addEventListener('resizeend', this.setHeaderHeightLive.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.lastScrollTrigger = 0;
      this.scrollThreshold = 50;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.searchButton = this.querySelector('.header__icon--search');
      if (this.searchButton) {
        this.searchButton.addEventListener('click', this.searchButtonClick.bind(this));
      }

      this.createObserver();
    }

    searchButtonClick() {
      this.preventHide = true;
      requestAnimationFrame(() => { this.preventHide = false; });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    setHeaderHeightLive(event, zero) {
      document.documentElement.style.setProperty('--header-height-live', `${zero ? 0 : this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      requestAnimationFrame(() => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

        // Only trigger actions if the scroll has changed by at least the threshold value
        if (Math.abs(scrollTop - this.lastScrollTrigger) < this.scrollThreshold) return;

        const scrollDifference = scrollTop - this.currentScrollTop;
        // Handle scrolling classes based on 50px sensitivity
        if (scrollDifference > 50 && this.pauseScrollListen !== true) {
          // Scrolling down
          this.pauseScrollListen = true;
          this.header.classList.add('scrolling-down');
          this.header.classList.remove('scrolling-up');
          setTimeout(() => { this.pauseScrollListen = false; }, 320);
        } else if (scrollDifference < -50 && this.pauseScrollListen !== true) {
          // Scrolling up
          this.pauseScrollListen = true;
          this.header.classList.add('scrolling-up');
          this.header.classList.remove('scrolling-down');
          setTimeout(() => { this.pauseScrollListen = false; }, 320);
        }

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          // Main logic for scrolling down
          this.header.classList.add('scrolled-past-header');
          if (this.preventHide) return;
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          // Main logic for scrolling up
          this.header.classList.add('scrolled-past-header');
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= this.headerBounds.top) {
          // Reset at the top
          this.header.classList.remove('scrolled-past-header');
          this.header.classList.remove('scrolling-down');
          this.header.classList.remove('scrolling-up');
          requestAnimationFrame(this.reset.bind(this));
        }

        this.currentScrollTop = scrollTop;
        this.lastScrollTrigger = scrollTop; // Update the last scroll position that triggered an action
      });
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
      this.setHeaderHeightLive(null, true);
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.setHeaderHeightLive();
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-readiness-capture"]) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-home-readiness-capture]');
    const day = 86400000;

    const readStorage = (storage, key) => {
      try {
        return storage.getItem(key);
      } catch (error) {
        return null;
      }
    };

    const writeStorage = (storage, key, value) => {
      try {
        storage.setItem(key, value);
      } catch (error) {
        // Storage can be unavailable in privacy-restricted browsing contexts.
      }
    };

    const removeStorage = (storage, key) => {
      try {
        storage.removeItem(key);
      } catch (error) {
        // Storage can be unavailable in privacy-restricted browsing contexts.
      }
    };

    roots.forEach((root) => {
      if (root.dataset.initialised === 'true' || root.dataset.enabled !== 'true') return;
      root.dataset.initialised = 'true';

      const dialog = root.querySelector('[data-readiness-dialog]');
      const closeButton = root.querySelector('[data-readiness-close]');
      const emailInput = root.querySelector('[data-readiness-email]');
      const deferredImage = root.querySelector('[data-readiness-image]');
      const form = root.closest('form');
      const dismissKey = root.dataset.dismissKey;
      const submitKey = root.dataset.submitKey;
      const hasErrors = root.dataset.hasErrors === 'true';
      const designMode = root.dataset.designMode === 'true';
      const reviewMode = new URLSearchParams(window.location.search).get('readiness_capture_review') === '1';
      const finePointer = window.matchMedia('(min-width: 750px) and (hover: hover) and (pointer: fine)');
      let timer = null;
      let returnFocus = null;
      let previousOverflow = '';
      let opened = false;

      const eventId = () => {
        if (window.crypto?.randomUUID) return window.crypto.randomUUID();
        return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
      };

      const emit = (eventName, detail = {}) => {
        const payload = {
          event_id: eventId(),
          source: 'home_readiness_popup',
          device_class: finePointer.matches ? 'desktop' : 'mobile',
          ...detail,
        };
        window.dataLayer = window.dataLayer || [];
        if (Array.isArray(window.dataLayer)) {
          window.dataLayer.push({ event: eventName, ...payload });
        }
        window.Shopify?.analytics?.publish?.(eventName, payload);
      };

      const isSuppressed = (key, days) => {
        const stored = Number(readStorage(window.localStorage, key));
        if (!stored) return false;
        if (Date.now() - stored < days * day) return true;
        removeStorage(window.localStorage, key);
        return false;
      };

      const loadImage = () => {
        if (!deferredImage || deferredImage.src) return;
        deferredImage.src = deferredImage.dataset.src;
        deferredImage.srcset = deferredImage.dataset.srcset;
      };

      const removeExitListener = () => document.removeEventListener('mouseout', onDesktopExit);

      const openDialog = (source) => {
        if (!dialog || dialog.open || opened) return;
        opened = true;
        if (timer) window.clearTimeout(timer);
        removeExitListener();
        loadImage();
        returnFocus = document.activeElement;
        previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        dialog.showModal();
        emit('home_readiness_capture_opened', { trigger: source });
        window.requestAnimationFrame(() => emailInput?.focus());
      };

      const closeDialog = (source) => {
        if (!dialog?.open) return;
        writeStorage(window.localStorage, dismissKey, String(Date.now()));
        emit('home_readiness_capture_dismissed', { trigger: source });
        dialog.close();
        document.body.style.overflow = previousOverflow;
        returnFocus?.focus?.();
      };

      function onDesktopExit(event) {
        if (event.clientY > 0 || event.relatedTarget !== null) return;
        openDialog('desktop_exit');
      }

      closeButton?.addEventListener('click', () => closeDialog('close_button'));
      dialog?.addEventListener('cancel', (event) => {
        event.preventDefault();
        closeDialog('escape');
      });
      dialog?.addEventListener('click', (event) => {
        if (event.target === dialog) closeDialog('backdrop');
      });
      form?.addEventListener('submit', () => {
        writeStorage(window.localStorage, submitKey, String(Date.now()));
        emit('home_readiness_capture_submit_attempt');
      });

      if (hasErrors) {
        removeStorage(window.localStorage, submitKey);
        openDialog('form_error');
        return;
      }

      const suppressed = !designMode && !reviewMode && (
        isSuppressed(dismissKey, Number(root.dataset.dismissDays)) ||
        isSuppressed(submitKey, Number(root.dataset.submitDays))
      );
      if (suppressed) return;

      if (designMode || reviewMode) {
        window.setTimeout(() => openDialog(designMode ? 'theme_editor' : 'review'), 50);
        return;
      }

      timer = window.setTimeout(
        () => openDialog('timer'),
        Number(root.dataset.delaySeconds) * 1000
      );
      if (finePointer.matches) document.addEventListener('mouseout', onDesktopExit);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-exit-capture"]) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-product-exit-capture]');
    const validVariants = new Set(['a', 'b']);

    const readStorage = (storage, key) => {
      try {
        return storage.getItem(key);
      } catch {
        return null;
      }
    };

    const writeStorage = (storage, key, value) => {
      try {
        storage.setItem(key, value);
      } catch {
        return;
      }
    };

    const removeStorage = (storage, key) => {
      try {
        storage.removeItem(key);
      } catch {
        return;
      }
    };

    const readCookie = (key) => {
      try {
        const prefix = `${encodeURIComponent(key)}=`;
        const row = document.cookie.split('; ').find((item) => item.startsWith(prefix));
        return row ? decodeURIComponent(row.slice(prefix.length)) : null;
      } catch {
        return null;
      }
    };

    const writeCookie = (key, value, days) => {
      try {
        const maxAge = Math.max(1, Math.round(days * 86400));
        document.cookie = `${encodeURIComponent(key)}=${encodeURIComponent(value)}; Max-Age=${maxAge}; Path=/; SameSite=Lax; Secure`;
      } catch {
        return;
      }
    };

    const randomPercent = () => {
      try {
        const values = new Uint32Array(1);
        window.crypto.getRandomValues(values);
        return (values[0] / 4294967296) * 100;
      } catch {
        return Math.random() * 100;
      }
    };

    const eventId = () => {
      try {
        return window.crypto.randomUUID();
      } catch {
        return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
      }
    };

    /* product-exit-scheduler:start */
    const scheduleCaptureTriggers = ({
      isMobile,
      mobileTeaserDelayMs,
      mobileOpenDelayMs,
      desktopArmDelayMs,
      desktopAttentionDelayMs,
      desktopOpenDelayMs,
      setTimer,
      armDesktopExit,
      showTeaser,
      openMobile,
      openDesktop,
    }) => {
      if (isMobile) {
        setTimer(() => showTeaser('mobile_teaser'), mobileTeaserDelayMs);
        setTimer(openMobile, mobileOpenDelayMs);
        return;
      }

      setTimer(armDesktopExit, desktopArmDelayMs);
      setTimer(() => showTeaser('desktop_attention'), desktopAttentionDelayMs);
      setTimer(openDesktop, desktopOpenDelayMs);
    };
    /* product-exit-scheduler:end */

    roots.forEach((root) => {
      if (root.dataset.initialised === 'true') return;
      root.dataset.initialised = 'true';

      if (root.dataset.enabled !== 'true') return;

      const dialog = root.querySelector('[data-exit-dialog]');
      const teaser = root.querySelector('[data-exit-teaser]');
      const teaserOpen = root.querySelector('[data-exit-teaser-open]');
      const teaserClose = root.querySelector('[data-exit-teaser-close]');
      const closeButton = root.querySelector('[data-exit-close]');
      const emailDismissButton = root.querySelector('[data-exit-email-dismiss]');
      const continueButton = root.querySelector('[data-exit-continue]');
      const deferredMedia = root.querySelectorAll('[data-exit-media]');
      const reasonButtons = root.querySelectorAll('[data-exit-reason]');
      const skipReasonButton = root.querySelector('[data-exit-reason-skip]');
      const reasonStep = root.querySelector('[data-exit-step="reasons"]');
      const emailStep = root.querySelector('[data-exit-step="email"]');
      const reasonHeading = root.querySelector('[data-exit-heading="reasons"]');
      const emailHeading = root.querySelector('[data-exit-heading="email"]');
      const successHeading = root.querySelector('[data-exit-heading="success"]');
      const emailInput = root.querySelector('[data-exit-email]');
      const tagsInput = root.querySelector('[data-exit-tags]');
      const form = root.closest('form');
      const submitButton = root.querySelector('[data-exit-submit]');
      const successStep = root.querySelector('[data-submit-success="true"]');
      const offerCopy = root.querySelectorAll('[data-exit-offer-copy]');
      const tradeLink = root.querySelector('[data-exit-trade-link]');
      const sessionKey = root.dataset.sessionKey;
      const dismissKey = root.dataset.dismissKey;
      const submitKey = root.dataset.submitKey;
      const experimentId = root.dataset.experimentId || 'product-exit-offer-v1';
      const experimentTag = root.dataset.experimentTag || root.dataset.defaultExperimentTag;
      const assignmentKey = `tmp_${experimentId}`;
      const submissionVariantKey = `${assignmentKey}_submitted_variant`;
      const reasonKey = `${assignmentKey}_reason`;
      const exposureKey = `${assignmentKey}_exposed`;
      const confirmedKey = `${assignmentKey}_confirmed_${root.dataset.productId}`;
      const scrollKey = `${assignmentKey}_scroll_y_${root.dataset.productId}`;
      const dismissDuration = Number(root.dataset.dismissDays) * 86400000;
      const submitDuration = Number(root.dataset.submitDays) * 86400000;
      const isMobile = window.matchMedia('(max-width: 749px), (hover: none), (pointer: coarse)');
      const compactOfferLayout = window.matchMedia('(max-width: 899px)');
      const qaAlwaysShow = root.dataset.qaAlwaysShow === 'true';
      const qaParameters = qaAlwaysShow ? new URLSearchParams(window.location.search) : null;
      const requestedQaVariant = qaParameters?.get('offer_review') || null;
      const requestedTestVariant = qaParameters?.get('offer_test') || null;
      const isQaReview = validVariants.has(requestedQaVariant);
      const isQaTimingTest = validVariants.has(requestedTestVariant);
      const submittedVariant = (successStep || root.dataset.hasErrors === 'true') ?
        readStorage(window.sessionStorage, submissionVariantKey) : null;
      const storedVariant = readStorage(window.localStorage, assignmentKey);
      const cookieVariant = readCookie(assignmentKey);
      const previewVariant = validVariants.has(requestedQaVariant) ? requestedQaVariant :
        validVariants.has(requestedTestVariant) ? requestedTestVariant :
        validVariants.has(submittedVariant) ? submittedVariant :
        validVariants.has(root.dataset.previewVariant) ? root.dataset.previewVariant : null;
      const allocatedVariant = randomPercent() < Number(root.dataset.variantAAllocation) ? 'a' : 'b';
      const offerVariant = previewVariant ||
        (validVariants.has(storedVariant) ? storedVariant : null) ||
        (validVariants.has(cookieVariant) ? cookieVariant : null) ||
        allocatedVariant;
      const offerTag = offerVariant === 'a' ? root.dataset.offerTagA : root.dataset.offerTagB;
      let selectedReason = readStorage(window.sessionStorage, reasonKey) || '';
      let exposedInMemory = false;
      let returnFocus = null;
      let previousOverflow = '';
      let desktopTriggerConsumed = false;
      let desktopExitHandler = null;
      let captureDismissedInMemory = false;
      let teaserSource = 'mobile_teaser';

      if (!previewVariant) {
        writeStorage(window.localStorage, assignmentKey, offerVariant);
        writeCookie(assignmentKey, offerVariant, Number(root.dataset.assignmentDays));
      }

      root.dataset.offerVariant = offerVariant;
      offerCopy.forEach((element) => {
        const copy = offerVariant === 'a' ? element.dataset.offerA : element.dataset.offerB;
        element.textContent = copy;
        element.hidden = copy.trim() === '';
      });

      const syncTags = () => {
        if (!tagsInput) return;
        tagsInput.value = [tagsInput.dataset.baseTags, experimentTag, offerTag, selectedReason]
          .filter(Boolean)
          .join(',');
      };

      syncTags();

      const emit = (eventName, detail = {}) => {
        const eventPayload = {
          event_id: eventId(),
          experiment_id: experimentId,
          offer_variant: offerVariant,
          device_class: isMobile.matches ? 'mobile' : 'desktop',
          product_id: root.dataset.productId,
          product_handle: root.dataset.productHandle,
          ...detail,
        };
        window.dataLayer = window.dataLayer || [];
        if (Array.isArray(window.dataLayer)) {
          window.dataLayer.push({ event: eventName, ...eventPayload });
        }
        window.Shopify?.analytics?.publish?.(eventName, eventPayload);
      };

      const recordExposure = (source) => {
        const alreadyRecorded = readStorage(window.sessionStorage, exposureKey) === 'true';
        if (alreadyRecorded || exposedInMemory) return;
        exposedInMemory = true;
        writeStorage(window.sessionStorage, exposureKey, 'true');
        emit('product_exit_offer_exposed', { source });
      };

      const isSuppressed = (key, duration) => {
        const stored = Number(readStorage(window.localStorage, key));
        if (!stored) return false;
        if (Date.now() - stored < duration) return true;
        removeStorage(window.localStorage, key);
        return false;
      };

      const markSeen = () => writeStorage(window.sessionStorage, sessionKey, 'true');
      const markDismissed = () => writeStorage(window.localStorage, dismissKey, String(Date.now()));
      const markSubmitted = () => writeStorage(window.localStorage, submitKey, String(Date.now()));

      const setDialogHeading = (heading) => {
        if (heading?.id && dialog) dialog.setAttribute('aria-labelledby', heading.id);
      };

      const loadDeferredMedia = () => {
        deferredMedia.forEach((media) => {
          if (media.dataset.exitDesktopOnly === 'true' && compactOfferLayout.matches) return;
          if (media.src) return;
          media.src = media.dataset.src;
          media.srcset = media.dataset.srcset;
        });
      };

      const restoreProductScroll = () => {
        const storedScroll = readStorage(window.sessionStorage, scrollKey);
        if (storedScroll !== null && Number.isFinite(Number(storedScroll))) {
          window.requestAnimationFrame(() => window.scrollTo(0, Number(storedScroll)));
          removeStorage(window.sessionStorage, scrollKey);
        }
        if (window.location.hash) {
          window.history?.replaceState?.(null, '', `${window.location.pathname}${window.location.search}`);
        }
      };

      const openDialog = (source) => {
        if (!dialog || dialog.open) return;
        returnFocus = document.activeElement;
        previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        if (teaser) teaser.hidden = true;
        loadDeferredMedia();
        dialog.showModal();
        markSeen();
        if (source !== 'success' && source !== 'form_error') {
          recordExposure(source);
          emit('product_exit_capture_opened', { source });
        }
        const target = successStep ? successHeading : (emailStep.hidden ? reasonHeading : emailInput);
        target?.focus();
      };

      const openFromDesktopTrigger = (source) => {
        if (desktopTriggerConsumed || captureDismissedInMemory) return;
        desktopTriggerConsumed = true;
        if (desktopExitHandler) document.removeEventListener('mouseout', desktopExitHandler);
        openDialog(source);
      };

      const openFromMobileTrigger = () => {
        if (captureDismissedInMemory) return;
        openDialog('mobile_auto');
      };

      const closeDialog = (shouldSuppress = true) => {
        if (!dialog?.open) return;
        if (shouldSuppress && !successStep) {
          captureDismissedInMemory = true;
          markDismissed();
          emit('product_exit_capture_dismissed');
        }
        dialog.close();
        document.body.style.overflow = previousOverflow;
        returnFocus?.focus?.();
      };

      const revealEmailStep = (button) => {
        selectedReason = button.dataset.reasonTag;
        writeStorage(window.sessionStorage, reasonKey, selectedReason);
        syncTags();
        const update = () => {
          reasonStep.hidden = true;
          emailStep.hidden = false;
        };
        if (document.startViewTransition) {
          document.startViewTransition(update);
        } else {
          update();
        }
        setDialogHeading(emailHeading);
        emit('product_exit_capture_reason_selected', { reason: selectedReason.split(':').pop() });
        emailInput?.focus();
      };

      const showTeaser = (source) => {
        if (!teaser || dialog?.open || captureDismissedInMemory) return;
        teaserSource = source;
        teaser.hidden = false;
        teaser.classList.toggle('is-attention', source === 'desktop_attention');
        if (source === 'desktop_attention') {
          teaser.addEventListener('animationend', () => teaser.classList.remove('is-attention'), { once: true });
        }
        markSeen();
        recordExposure(source);
      };

      if (successStep) {
        setDialogHeading(successHeading);
        markSubmitted();
        removeStorage(window.localStorage, dismissKey);
        removeStorage(window.sessionStorage, reasonKey);
        if (readStorage(window.sessionStorage, confirmedKey) !== 'true') {
          writeStorage(window.sessionStorage, confirmedKey, 'true');
          emit('product_exit_capture_submit_confirmed');
        }
        openDialog('success');
        restoreProductScroll();
      } else if (root.dataset.hasErrors === 'true') {
        setDialogHeading(emailHeading);
        openDialog('form_error');
      } else if (isQaReview) {
        setDialogHeading(reasonHeading);
        window.setTimeout(() => openDialog('qa_preview'), 50);
      } else {
        const alreadySeen = isQaTimingTest ? false : readStorage(window.sessionStorage, sessionKey) === 'true';
        const dismissed = isQaTimingTest ? false : isSuppressed(dismissKey, dismissDuration);
        const submitted = isQaTimingTest ? false : isSuppressed(submitKey, submitDuration);

        if (!alreadySeen && !dismissed && !submitted) {
          scheduleCaptureTriggers({
            isMobile: isMobile.matches,
            mobileTeaserDelayMs: Number(root.dataset.mobileDelay) * 1000,
            mobileOpenDelayMs: Number(root.dataset.mobileOpen) * 1000,
            desktopArmDelayMs: Number(root.dataset.desktopDwell) * 1000,
            desktopAttentionDelayMs: Number(root.dataset.desktopAttention) * 1000,
            desktopOpenDelayMs: Number(root.dataset.desktopFallback) * 1000,
            setTimer: window.setTimeout.bind(window),
            armDesktopExit: () => {
              desktopExitHandler = (event) => {
                if (event.clientY > 0 || event.relatedTarget !== null) return;
                openFromDesktopTrigger('desktop_exit');
              };
              document.addEventListener('mouseout', desktopExitHandler);
            },
            showTeaser,
            openMobile: openFromMobileTrigger,
            openDesktop: () => openFromDesktopTrigger('desktop_auto'),
          });
        }
      }

      teaserOpen?.addEventListener('click', () => openDialog(teaserSource));
      teaserClose?.addEventListener('click', () => {
        captureDismissedInMemory = true;
        if (desktopExitHandler) document.removeEventListener('mouseout', desktopExitHandler);
        teaser.hidden = true;
        markDismissed();
        emit('product_exit_capture_dismissed', { source: teaserSource });
      });
      closeButton?.addEventListener('click', () => closeDialog(true));
      emailDismissButton?.addEventListener('click', () => closeDialog(true));
      continueButton?.addEventListener('click', () => closeDialog(false));
      reasonButtons.forEach((button) => button.addEventListener('click', () => revealEmailStep(button)));
      skipReasonButton?.addEventListener('click', () => revealEmailStep(skipReasonButton));
      tradeLink?.addEventListener('click', () => emit('product_exit_trade_link_clicked'));

      dialog?.addEventListener('cancel', (event) => {
        event.preventDefault();
        closeDialog(true);
      });

      dialog?.addEventListener('click', (event) => {
        if (event.target === dialog) closeDialog(true);
      });

      form?.addEventListener('submit', () => {
        if (!form.checkValidity()) return;
        writeStorage(window.sessionStorage, submissionVariantKey, offerVariant);
        writeStorage(window.sessionStorage, scrollKey, String(window.scrollY));
        syncTags();
        emit('product_exit_capture_submit_attempt', {
          reason: selectedReason ? selectedReason.split(':').pop() : undefined,
        });
        submitButton.disabled = true;
        submitButton.setAttribute('aria-busy', 'true');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
